import { useState, useEffect } from "react";
import DialogComponent, { DrawerComponent, Modal } from "src/components/DialogComponent";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import _ from "lodash";
import { getItemsRequest, updateItemRequest } from "src/modules/spItems/api";
import { selectCurrentUser, selectUsers } from "src/modules/users/selector";
import Form from "src/components/Form";
import { selectGetItemStatus, selectItem, selectItems } from "src/modules/spItems/selectors";
import { myTasksDependListName, myTasksLocationsListName } from "src/api/config/myTasksLists.config";
import { clearItem, getItem, getItems } from "src/modules/spItems/actions";
import moment from "moment";
import {
  myTasksIncidentCardRecipientsListName,
  myTasksIncidentsQuestionsListName,
  myTasksIncidentstListName,
  myTasksTypeIncidentsListName
} from "src/api/config/myTasksInc.config";
import { emailsSender, equipmentsListName, paramsListName, siteUrl } from "src/api/config";
import { myTasks5WayListName, myTasksSDCA5WayListName } from "src/api/config/myTasks5Way.config";
import { useNavigate, useSearchParams } from "react-router-dom";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import Statuses from "./components/statuses";
import { TooltipItem } from "src/utils/Tooltip";
import { CancelIcon } from "src/components/ui-icons/myTasks/cancel";
import TGButton from "src/components/ui/TGButton";
import { myTaskActionsListName } from "src/api/config/myTasksActions.config";
import Loading from "src/components/Loading";
import LoadingOpBg from "src/components/LoadingOpBg";
import Button from "src/components/Button";
import { RootState } from "src/store/rootReducer";
import { DownloadWithHoverIcon } from "src/components/ui-icons/upload/DownloadIcon";
import { Letter } from "src/components/ui-icons/myTasks/letter";
import html2canvas from "html2canvas";
import PptxGenJS from "pptxgenjs";
import { downloadOutlookEmailWithAttachments, urlDefault, urlPreview } from "src/constants";
import { emailAPI } from "src/utils/api.utils";
import { incStatus, incTrigger, incTypes, nTrigger } from "src/api/config/systemSwitch";
import { ClosePanelBtnMobile } from "src/components/DialogComponent";
import {UserAvatar} from "src/components/ui/avatar/Avatar";
const { sendEmail } = emailAPI();

const IncidentCard = ({
  zIndex,
  open,
  setOpen,
  incidentID,
}: {
  zIndex: number;
  open: boolean;
  setOpen: any;
  incidentID: number;
}) => {
  const dispatch = useAppDispatch();
  const currentUser: any = useAppSelector((state) => selectCurrentUser(state));
  const [fields, setFields] = useState<any>([]);
  const [dependenceFields, setDependenceFields] = useState<any>({
    Location: null,
    Department: null,
    Region: null,
  });
  const [formData, setFormData] = useState<any>(null);
  const [defaultValues, setDefaultValues] = useState<any>({});
  const [customLoading, setCustomLoading] = useState(true);
  const [incQuestions, setIncQuestions] = useState<any>([]);
  const locations: any = useAppSelector((state) => selectItems(state, myTasksLocationsListName));
  const dependencies: any = useAppSelector((state) => selectItems(state, myTasksDependListName));
  const typesIncList: any = useAppSelector((state) => selectItems(state, myTasksTypeIncidentsListName));
  const incCard: any = useAppSelector((state) => selectItem(state, myTasksIncidentstListName));
  const incCardStatus = useAppSelector((state) => selectGetItemStatus(state, myTasksIncidentstListName));
  const users: any = useAppSelector(selectUsers);
  const [checkLoadUsers, setCheckLoadUsers] = useState(false);
  const [renderInc, setRenderInc] = useState(false);
  const [getInc, setGetInc] = useState(false);
  const [currentFormData, setCurrentFormData] = useState<any>(null);
  const [typesInc, setTypesInc] = useState<any>([]);
  const [currentTypeInc, setCurrentTypeInc] = useState<any>(null);
  const [incKeys, setIncKeys] = useState<any>([]);
  const navigate = useNavigate();
  const [ID5Way, setID5Way] = useState(0);
  const [card5WayTree, setCard5WayTree] = useState<any>([]);
  const params: any = useAppSelector((state) => selectItems(state, paramsListName));
  const [cancelModal, setCancelModal] = useState(false);
  const [returnToWorkModal, setReturnToWorkModal] = useState(false);
  const [invCompletedModal, setInvCompletedModal] = useState(false);
  const [pptxLoading, setPptxLoading] = useState(false);
  const statusUsers: string = useAppSelector((state: RootState) => state.users.status);
  const [modalEml, setModalEml] = useState(false);
  const [loadingEml, setLoadingEml] = useState(false);
  const [titleEmlPptx, setTitleEmlPptx] = useState("");
  const [incCardQuestionsEml, setIncCardQuestionsEml] = useState<any>(null);
  const [actionsEml, setActionsEml] = useState<any>([]);
  const [query, setQuery] = useSearchParams();

  useEffect(() => {
    return () => {
      dispatch(clearItem({ listName: myTasksIncidentstListName }));
    };
  }, []);

  //Расставляем опции селектов локации, типа сотрудников
  useEffect(() => {
    if (currentUser.id && renderInc) {
      const tempFieldsForm = [...fields];
      for (let i = 0; i < tempFieldsForm.length; i++) {
        if (tempFieldsForm[i]["key"] === "Location") {
          const options = locations.filter((location: any) => {
            if (
              currentUser.isAdmin ||
              (currentUser.isLocationEditorMyTasks &&
                currentUser.isLocationEditorMyTasks.length > 0 &&
                currentUser.isLocationEditorMyTasks.find(
                  (locationID: any) => locationID === location.ID
                )) ||
              (currentUser.isLocationAdminMyTasks &&
                currentUser.isLocationAdminMyTasks.length > 0 &&
                currentUser.isLocationAdminMyTasks.find(
                  (locationID: any) => locationID === location.ID
                ))
            ) {
              return true
            } else {
              return false
            }
          }).map((location: any) => {
            return {
              id: location.ID,
              name: location.Title,
              available: true,
            };
          });
          tempFieldsForm[i]["options"] = [...options];
        }
        if (tempFieldsForm[i]["key"] === "TypeIncident") {
          tempFieldsForm[i]["optionsInputs"] = typesInc.map((type: any) => type.Title.trim()) || [];
        }
      }
      setFields([...tempFieldsForm]);
    }
  }, [locations, currentUser, renderInc, typesInc]);

  useEffect(() => {
    if (typesIncList.length > 0) {
      setTypesInc(typesIncList.filter((type: any) => type.ID !== incTypes.security));
    }
  }, [typesIncList]);

  useEffect(() => {
    if (dependenceFields["Location"] && renderInc) {
      dispatch(
        getItems({ listName: myTasksDependListName, filters: { Location: dependenceFields["Location"]["id"] } })
      );
      const tempFieldsForm = [...fields];
      for (let i = 0; i < tempFieldsForm.length; i++) {
        if (tempFieldsForm[i]["key"] === "Department") {
          tempFieldsForm[i]["disabled"] = false;
        }
        if (tempFieldsForm[i]["key"] === "Region") {
          tempFieldsForm[i]["disabled"] = true;
        }
      }
      setFields([...tempFieldsForm]);
    }
    if (!dependenceFields["Location"] && renderInc) {
      const tempFieldsForm = [...fields];
      for (let i = 0; i < tempFieldsForm.length; i++) {
        if (tempFieldsForm[i]["key"] === "Department" || tempFieldsForm[i]["key"] === "Region") {
          tempFieldsForm[i]["disabled"] = true;
        }
      }
      setFields([...tempFieldsForm]);
    }
    if (dependenceFields["Department"] && renderInc) {
      const tempFieldsForm = [...fields];
      for (let i = 0; i < tempFieldsForm.length; i++) {
        if (tempFieldsForm[i]["key"] === "Region") {
          tempFieldsForm[i]["disabled"] = false;
        }
      }
      setFields([...tempFieldsForm]);
    }
  }, [dependenceFields, renderInc]);

  useEffect(() => {
    if (renderInc) {
      const tempFieldsForm = [...fields];
      for (let i = 0; i < tempFieldsForm.length; i++) {
        if (dependenceFields["Location"]) {
          if (tempFieldsForm[i]["key"] === "Department") {
            const options = dependencies
              .filter((dependence: any) => dependence.Location.ID === dependenceFields["Location"]["id"])
              .map((dependence: any) => {
                return {
                  id: dependence.Departament.ID,
                  name: dependence.Departament.Title,
                };
              });
            tempFieldsForm[i]["options"] = _.uniqWith(options, _.isEqual);
          }
        }
        if (dependenceFields["Department"]) {
          if (tempFieldsForm[i]["key"] === "Region") {
            const options = dependencies
              .filter(
                (dependence: any) =>
                  dependence.Location.ID === dependenceFields["Location"]["id"] &&
                  dependence.Departament.ID === dependenceFields["Department"]["id"]
              )
              .map((dependence: any) => {
                return {
                  id: dependence.Region.ID,
                  name: dependence.Region.Title,
                };
              });
            tempFieldsForm[i]["options"] = _.uniqWith(options, _.isEqual);
          }
        }
      }
      setFields([...tempFieldsForm]);
    }
  }, [dependencies, renderInc]);

  useEffect(() => {
    if (formData && Object.keys(formData).length > 0) {
      setCustomLoading(true);
      let tempIncObj: any = {};
      Object.keys(formData).map((key) => {
        if (incKeys.some((incKey: string) => incKey === key)) {
          if (Array.isArray(formData[key])) {
            if (formData[key].some(item => typeof item === 'object' && item.hasOwnProperty('SAP_MESSAGE'))) {
              formData[key].sort((a: any, b: any) => {
                return a.SAP_MESSAGE.localeCompare(b.SAP_MESSAGE);
              });
            } else if (formData[key].some(item => typeof item === 'object' && item.hasOwnProperty('name'))) {
              formData[key].sort((a: any, b: any) => {
                return a.name.localeCompare(b.name);
              });
            } else if (formData[key].some(item => typeof item === 'object' && item.hasOwnProperty('email'))) {
              formData[key].sort((a: any, b: any) => {
                return a.email.localeCompare(b.email);
              });
            } else if (formData[key].some(item => typeof item === 'object' && item.hasOwnProperty('SAP'))) {
              formData[key].sort((a: any, b: any) => {
                return a.SAP.SAP.localeCompare(b.SAP.SAP);
              });
            } else {
              formData[key].sort((a: any, b: any) => {
                return a.localeCompare(b);
              });
            }
          }
          tempIncObj[key] = formData[key];
        }
      });
      const idCurrentTypeInc = typesInc.filter((type: any) => type.Title === currentTypeInc)[0]["ID"];
      let closedDate =
        (typeof formData.DateIncidents.startDate === "string" && new Date(formData.DateIncidents.startDate)) ||
        formData.DateIncidents.startDate;
      if (formData.IncidentOption === "Инцидент") {
       if (idCurrentTypeInc === incTypes.safe) {
          //Безопасность
          const days = Number(params.find((param: any) => param.Key === "IncSafeDate")["Value"].trim());
          closedDate = moment(closedDate).add(days, "days").toDate();
        }
        if (idCurrentTypeInc === incTypes.e) {
          //Экология
          const days = Number(params.find((param: any) => param.Key === "IncEnvDate")["Value"].trim());
          closedDate = moment(closedDate).add(days, "days").toDate();
        }
        if (idCurrentTypeInc === incTypes.q) {
          //Качество
          if (formData.QAIncidentType === "Инцидент по качеству") {
            const days = Number(params.find((param: any) => param.Key === "IncQualityDate")["Value"].trim());
            closedDate = moment(closedDate).add(days, "days").toDate();
          }
          if (formData.QAIncidentType === "Инцидент в процессе") {
            const days = Number(params.find((param: any) => param.Key === "IncProcessDate")["Value"].trim());
            closedDate = moment(closedDate).add(days, "days").toDate();
          }
        }
        if (idCurrentTypeInc === incTypes.m) {
          //Техобслуживание
          const days = Number(params.find((param: any) => param.Key === "IncMDate")["Value"].trim());
          closedDate = moment(closedDate).add(days, "days").toDate();
        }
      }
      if (formData.IncidentOption === "Несоответствие") {
        if (idCurrentTypeInc === incTypes.safe) {
          //Безопасность
          const days = Number(params.find((param: any) => param.Key === "NSafeDate")["Value"].trim());
          closedDate = moment(closedDate).add(days, "days").toDate();
        }
        if (idCurrentTypeInc === incTypes.e) {
          //Экология
          const days = Number(params.find((param: any) => param.Key === "NEnvDate")["Value"].trim());
          closedDate = moment(closedDate).add(days, "days").toDate();
        }
        if (idCurrentTypeInc === incTypes.q) {
          //Качество
          const days = Number(params.find((param: any) => param.Key === "NQualityDate")["Value"].trim());
          closedDate = moment(closedDate).add(days, "days").toDate();
        }
        if (idCurrentTypeInc === incTypes.m) {
          //Техобслуживание
          const days = Number(params.find((param: any) => param.Key === "NMDate")["Value"].trim());
          closedDate = moment(closedDate).add(days, "days").toDate();
        }
      }
      const sendData = {
        ID: incidentID,
        Questions: JSON.stringify(tempIncObj),
        TypeIncident: idCurrentTypeInc,
        TimeIncident: formData.TimeIncident,
        Responsible: formData.Responsible[0]["value"],
        ResponsibleEmail: formData.Responsible[0]["value"],
        Title: `${formData.IncidentOption}. ${formData.TypeIncident}.${(formData.QAIncidentType && ` ${formData.QAIncidentType}.`) || ""
          } От ${moment(
            (typeof formData.DateIncidents.startDate === "string" && new Date(formData.DateIncidents.startDate)) ||
            formData.DateIncidents.startDate
          ).format("DD.MM.YYYY")}`,
        DateIncidents:
          (typeof formData.DateIncidents.startDate === "string" && new Date(formData.DateIncidents.startDate)) ||
          formData.DateIncidents.startDate,
        DateIncidents2:
          (typeof formData.DateIncidents2.startDate === "string" && new Date(formData.DateIncidents2.startDate)) ||
          formData.DateIncidents2.startDate,
        Location: formData.Location.id,
        Department: formData.Department.id,
        Region: formData.Region.id,
        Description: formData.Description.trim() + " ",
        ClosedDate: closedDate,
      };
      // console.log('update_sendData: ', sendData);
      updateItemRequest({ listName: myTasksIncidentstListName, body: sendData })
        .then((value: any) => {
          const updateIncID = value[0];
          getItemsRequest({ listName: myTasks5WayListName, filters: { Incident: updateIncID } }).then((results) => {
            if (results.items.length > 0) {
              const card5WayID = results.items[0]["ID"];
              let trigger: any;
              if (formData.TypeIncident) {
                if (idCurrentTypeInc === incTypes.safe) {
                  if (formData.IncidentOption === "Инцидент") {
                    trigger = incTrigger.safe;
                  }
                  if (formData.IncidentOption === "Несоответствие") {
                    trigger = nTrigger.safe;
                  }
                }
                if (idCurrentTypeInc === incTypes.e) {
                  if (formData.IncidentOption === "Инцидент") {
                    trigger = incTrigger.e;
                  }
                  if (formData.IncidentOption === "Несоответствие") {
                    trigger = nTrigger.e;
                  }
                }
                if (idCurrentTypeInc === incTypes.q) {
                  if (formData.IncidentOption === "Инцидент") {
                    if (formData.QAIncidentType === "Инцидент в процессе") {
                      trigger = incTrigger.process;
                    }
                    if (formData.QAIncidentType === "Инцидент по качеству") {
                      trigger = incTrigger.q;
                    }
                  }
                  if (formData.IncidentOption === "Несоответствие") {
                    trigger = nTrigger.q;
                  }
                }
                if (idCurrentTypeInc === incTypes.m) {
                  if (formData.IncidentOption === "Инцидент") {
                    trigger = incTrigger.m;
                  }
                  if (formData.IncidentOption === "Несоответствие") {
                    trigger = nTrigger.m;
                  }
                }
              }
              const sendData5Way = {
                ID: card5WayID,
                Location: formData.Location.id,
                Department: formData.Department.id,
                Region: formData.Region.id,
                Trigger: trigger,
              };
              updateItemRequest({ listName: myTasks5WayListName, body: sendData5Way }).then(() => {
                if (formData.IncidentOption === "Несоответствие") {
                  getItemsRequest({
                    listName: myTaskActionsListName,
                    filters: {
                      ImportantHashTag: `#${JSON.parse(incCard.Questions)["IncidentOption"]}_${incCard["TypeIncident"]["Title"]
                        }_${incCard.ID}*`.toLowerCase(),
                    },
                  }).then((results) => {
                    const actions = [...results.items];
                    if (actions.length > 0) {
                      let updateDataActions: any = [];
                      actions.map((action) => {
                        let newDesc: any = "";
                        if (action.Description) {
                          newDesc = action.Description.replaceAll(
                            `#${JSON.parse(incCard.Questions)["IncidentOption"]}_${incCard["TypeIncident"]["Title"]}`
                              .toLowerCase()
                              .trim(),
                            `#${formData["IncidentOption"]}_${formData["TypeIncident"]}`.toLowerCase().trim()
                          );
                        }
                        updateDataActions = [
                          ...updateDataActions,
                          {
                            ID: action.ID,
                            Description: newDesc || action.Description,
                            ImportantHashTag: `#${formData["IncidentOption"]}_${formData["TypeIncident"]}_${incCard.ID}`
                              .toLowerCase()
                              .trim(),
                          },
                        ];
                      });
                      if (updateDataActions.length > 0) {
                        updateItemRequest({
                          listName: myTaskActionsListName,
                          body: updateDataActions[0],
                          bodyArr: updateDataActions,
                        }).then(() => {
                          setGetInc(!getInc);
                          setCustomLoading(false);
                        });
                      }
                    } else {
                      setGetInc(!getInc);
                      setCustomLoading(false);
                    }
                  });
                } else {
                  setGetInc(!getInc);
                  setCustomLoading(false);
                }
              });
            } else {
              if (formData.IncidentOption === "Несоответствие") {
                getItemsRequest({
                  listName: myTaskActionsListName,
                  filters: {
                    ImportantHashTag: `#${JSON.parse(incCard.Questions)["IncidentOption"]}_${incCard["TypeIncident"]["Title"]
                      }_${incCard.ID}*`.toLowerCase(),
                  },
                }).then((results) => {
                  const actions = [...results.items];
                  if (actions.length > 0) {
                    let updateDataActions: any = [];
                    actions.map((action) => {
                      updateDataActions = [
                        ...updateDataActions,
                        {
                          ID: action.ID,
                          Description:
                            action.Description &&
                            action.Description.replace(
                              `#${JSON.parse(incCard.Questions)["IncidentOption"]}_${incCard["TypeIncident"]["Title"]}`
                                .toLowerCase()
                                .trim(),
                              `#${formData["IncidentOption"]}_${formData["TypeIncident"]}`.toLowerCase().trim()
                            ),
                          ImportantHashTag: `#${formData["IncidentOption"]}_${formData["TypeIncident"]}_${incCard.ID}`
                            .toLowerCase()
                            .trim(),
                        },
                      ];
                    });
                    if (updateDataActions.length > 0) {
                      updateItemRequest({
                        listName: myTaskActionsListName,
                        body: updateDataActions[0],
                        bodyArr: updateDataActions,
                      }).then(() => {
                        if (localStorage.getItem("OpenAdd5WayCardForm")) {
                          localStorage.setItem("OpenAdd5WayCardForm", "");
                          let trigger: any;
                          if (formData.TypeIncident) {
                            const idCurrentTypeInc = typesInc.filter(
                              (type: any) => type.Title === formData.TypeIncident
                            )[0]["ID"];
                            if (idCurrentTypeInc === incTypes.safe) {
                              if (formData.IncidentOption === "Инцидент") {
                                trigger = { name: "Инцидент по Безопасности", id: incTrigger.safe };
                              }
                              if (formData.IncidentOption === "Несоответствие") {
                                trigger = { name: "Несоответствие по Безопасности", id: nTrigger.safe };
                              }
                            }
                            if (idCurrentTypeInc === incTypes.e) {
                              if (formData.IncidentOption === "Инцидент") {
                                trigger = { name: "Инцидент по Экологии", id: incTrigger.e };
                              }
                              if (formData.IncidentOption === "Несоответствие") {
                                trigger = { name: "Несоответствие по Экологии", id: nTrigger.e };
                              }
                            }
                            if (idCurrentTypeInc === incTypes.q) {
                              if (formData.IncidentOption === "Инцидент") {
                                if (formData.QAIncidentType === "Инцидент в процессе") {
                                  trigger = { name: "Инцидент в процессе", id: incTrigger.process };
                                }
                                if (formData.QAIncidentType === "Инцидент по качеству") {
                                  trigger = { name: "Инцидент по Качеству", id: incTrigger.q };
                                }
                              }
                              if (formData.IncidentOption === "Несоответствие") {
                                trigger = { name: "Несоответствие по Качеству", id: nTrigger.q };
                              }
                            }
                            if (idCurrentTypeInc === incTypes.m) {
                              if (formData.IncidentOption === "Инцидент") {
                                trigger = { name: "Инцидент по Техобслуживанию", id: incTrigger.m };
                              }
                              if (formData.IncidentOption === "Несоответствие") {
                                trigger = { name: "Несоответствие по Техобслуживанию", id: nTrigger.m };
                              }
                            }
                          }
                          localStorage.setItem(
                            "default5WayCardDataInc",
                            JSON.stringify({
                              Location: formData.Location,
                              Department: formData.Department,
                              Region: formData.Region,
                              Trigger: trigger,
                            })
                          );
                          localStorage.setItem("NEW_INC", String(incidentID));
                          setCustomLoading(false);
                          if (formData.IncidentOption && formData.IncidentOption === "Инцидент") {
                            navigate("/dashboard/3/deviation-reports");
                          }
                          if (formData.IncidentOption && formData.IncidentOption === "Несоответствие") {
                            navigate("/dashboard/3/5-whys");
                          }
                        } else {
                          setGetInc(!getInc);
                          setCustomLoading(false);
                        }
                      });
                    }
                  } else {
                    if (localStorage.getItem("OpenAdd5WayCardForm")) {
                      localStorage.setItem("OpenAdd5WayCardForm", "");
                      let trigger: any;
                      if (formData.TypeIncident) {
                        const idCurrentTypeInc = typesInc.filter(
                          (type: any) => type.Title === formData.TypeIncident
                        )[0]["ID"];
                        if (idCurrentTypeInc === incTypes.safe) {
                          if (formData.IncidentOption === "Инцидент") {
                            trigger = { name: "Инцидент по Безопасности", id: incTrigger.safe };
                          }
                          if (formData.IncidentOption === "Несоответствие") {
                            trigger = { name: "Несоответствие по Безопасности", id: nTrigger.safe };
                          }
                        }
                        if (idCurrentTypeInc === incTypes.e) {
                          if (formData.IncidentOption === "Инцидент") {
                            trigger = { name: "Инцидент по Экологии", id: incTrigger.e };
                          }
                          if (formData.IncidentOption === "Несоответствие") {
                            trigger = { name: "Несоответствие по Экологии", id: nTrigger.e };
                          }
                        }
                        if (idCurrentTypeInc === incTypes.q) {
                          if (formData.IncidentOption === "Инцидент") {
                            if (formData.QAIncidentType === "Инцидент в процессе") {
                              trigger = { name: "Инцидент в процессе", id: incTrigger.process };
                            }
                            if (formData.QAIncidentType === "Инцидент по качеству") {
                              trigger = { name: "Инцидент по Качеству", id: incTrigger.q };
                            }
                          }
                          if (formData.IncidentOption === "Несоответствие") {
                            trigger = { name: "Несоответствие по Качеству", id: nTrigger.q };
                          }
                        }
                        if (idCurrentTypeInc === incTypes.m) {
                          if (formData.IncidentOption === "Инцидент") {
                            trigger = { name: "Инцидент по Техобслуживанию", id: incTrigger.m };
                          }
                          if (formData.IncidentOption === "Несоответствие") {
                            trigger = { name: "Несоответствие по Техобслуживанию", id: nTrigger.m };
                          }
                        }
                      }
                      localStorage.setItem(
                        "default5WayCardDataInc",
                        JSON.stringify({
                          Location: formData.Location,
                          Department: formData.Department,
                          Region: formData.Region,
                          Trigger: trigger,
                        })
                      );
                      localStorage.setItem("NEW_INC", String(incidentID));
                      setCustomLoading(false);
                      if (formData.IncidentOption && formData.IncidentOption === "Инцидент") {
                        navigate("/dashboard/3/deviation-reports");
                      }
                      if (formData.IncidentOption && formData.IncidentOption === "Несоответствие") {
                        navigate("/dashboard/3/5-whys");
                      }
                    } else {
                      setGetInc(!getInc);
                      setCustomLoading(false);
                    }
                  }
                });
              } else {
                              if (localStorage.getItem("OpenAdd5WayCardForm")) {
                                localStorage.setItem("OpenAdd5WayCardForm", "");
                                let trigger: any;
                                if (formData.TypeIncident) {
                                  const idCurrentTypeInc = typesInc.filter((type: any) => type.Title === formData.TypeIncident)[0][
                                    "ID"
                                  ];
                                  if (idCurrentTypeInc === incTypes.safe) {
                                    if (formData.IncidentOption === "Инцидент") {
                                      trigger = { name: "Инцидент по Безопасности", id: incTrigger.safe };
                                    }
                                    if (formData.IncidentOption === "Несоответствие") {
                                      trigger = { name: "Несоответствие по Безопасности", id: nTrigger.safe };
                                    }
                                  }
                                  if (idCurrentTypeInc === incTypes.e) {
                                    if (formData.IncidentOption === "Инцидент") {
                                      trigger = { name: "Инцидент по Экологии", id: incTrigger.e };
                                    }
                                    if (formData.IncidentOption === "Несоответствие") {
                                      trigger = { name: "Несоответствие по Экологии", id: nTrigger.safe };
                                    }
                                  }
                                  if (idCurrentTypeInc === incTypes.q) {
                                    if (formData.IncidentOption === "Инцидент") {
                                      if (formData.QAIncidentType === "Инцидент в процессе") {
                                        trigger = { name: "Инцидент в процессе", id: incTrigger.process };
                                      }
                                      if (formData.QAIncidentType === "Инцидент по качеству") {
                                        trigger = { name: "Инцидент по Качеству", id: incTrigger.q };
                                      }
                                    }
                                    if (formData.IncidentOption === "Несоответствие") {
                                      trigger = { name: "Несоответствие по Качеству", id: nTrigger.q };
                                    }
                                  }
                                  if (idCurrentTypeInc === incTypes.m) {
                                    if (formData.IncidentOption === "Инцидент") {
                                      trigger = { name: "Инцидент по Техобслуживанию", id: incTrigger.m };
                                    }
                                    if (formData.IncidentOption === "Несоответствие") {
                                      trigger = { name: "Несоответствие по Техобслуживанию", id: nTrigger.m };
                                    }
                                  }
                                }
                                localStorage.setItem(
                                  "default5WayCardDataInc",
                                  JSON.stringify({
                                    Location: formData.Location,
                                    Department: formData.Department,
                                    Region: formData.Region,
                                    Trigger: trigger,
                                  })
                                );
                                localStorage.setItem("NEW_INC", String(incidentID));
                                setCustomLoading(false);
                                if (formData.IncidentOption && formData.IncidentOption === "Инцидент") {
                                  navigate("/dashboard/3/deviation-reports");
                                }
                                if (formData.IncidentOption && formData.IncidentOption === "Несоответствие") {
                                  navigate("/dashboard/3/5-whys");
                                }
                              } else {
                                setGetInc(!getInc);
                                setCustomLoading(false);
                              }
                            }
            }
          });
        })
        .catch((error) => {
          console.error("Ошибка:", error);
          setCustomLoading(false);
        });
    } else if (incCardStatus === "SUCCESS") {
      setCustomLoading(false);
    }
  }, [formData]);

  useEffect(() => {
    if (incQuestions.length > 0) {
      setFields([...incQuestions]);
      setRenderInc(true);
    }
  }, [incQuestions]);

  useEffect(() => {
    const tempFieldsForm = [...fields];
    let tempKeys: any = [];
    for (let i = 0; i < tempFieldsForm.length; i++) {
      const field = tempFieldsForm[i];
      if (!field.hide && (field.condition || field.key === 'IncidentOption' || field.key === 'QAIncidentType')) {
        tempKeys = [...tempKeys, field.key];
      }
    }
    setIncKeys([...tempKeys]);
  }, [fields]);

  useEffect(() => {
    if (currentTypeInc && typesInc.length > 0) {
      setRenderInc(false);
      const idCurrentTypeInc = typesInc.filter((type: any) => type.Title === currentTypeInc)[0]["ID"];
      setCustomLoading(true);
      getItemsRequest({
        listName: myTasksIncidentsQuestionsListName,
        filters: { TypeIncident: idCurrentTypeInc },
        sortOrder: { name: "Order0", asc: true },
      }).then((results) => {
        const tempIncQuestions = [...results.items];
        let incFieldsForm: any = [];
        incFieldsForm = [
          ...incFieldsForm,
          ...[
            {
              type: "date",
              require: true,
              key: "DateIncidents",
              title: 'Дата регистрации несоответствия/инцидента',
              minDate: moment(new Date()).subtract(7, "days").toDate(),
              maxDate: moment(new Date()).toDate(),
              placeholder: "дд.мм.гггг",
              condition: null,
              width: "w-full",
            },
            {
              type: 'date',
              require: true,
              key: 'DateIncidents2',
              title: 'Дата несоответсвия/инцидента',
              maxDate: moment(new Date()).toDate(),
              placeholder: 'дд.мм.гггг',
              condition: null,
              width: 'w-full'
            },
            {
              type: "time",
              require: false,
              key: "TimeIncident",
              title: "Время несоответствия/инцидента",
              placeholder: "чч:мм",
              condition: null,
              width: "w-full",
            },
            {
              type: "radio",
              require: true,
              title: "Тип несоответствия/инцидента",
              key: "TypeIncident",
              condition: null,
              width: "w-full",
            },
          ],
        ];
        tempIncQuestions.forEach((item) => {
          if (item.Key === "IncidentOption" || item.Key === "QAIncidentType") {
            incFieldsForm = [
              ...incFieldsForm,
              {
                type: item.TypeQuestion,
                require: item.Require,
                noticeAnswers:
                  (item.NoticeAnswers &&
                    JSON.parse(item.NoticeAnswers).filter((notice: any) => notice.TypeIncident === currentTypeInc)
                      .length > 0 &&
                    JSON.parse(item.NoticeAnswers).filter((notice: any) => notice.TypeIncident === currentTypeInc)[0][
                    "Notice"
                    ]) ||
                  null,
                notice: item.Notice,
                noticeIcon: (item.Notice && true) || false,
                key: item.Key,
                title: item.Title,
                hide: item.DefaultHide,
                width: item.Width,
                optionsInputs: (item.Options && item.Options.split(";").map((option) => option.trim())) || [],
                condition: item.Condition && JSON.parse(item.Condition),
              },
            ];
          }
        });
        incFieldsForm = [
          ...incFieldsForm,
          ...[
            {
              type: "peoplePicker",
              require: true,
              single: true,
              key: "Responsible",
              title: "ФИО инициатора",
              current: true,
              condition: null,
              placeholder: "Введите имя или фамилию",
              width: "w-full",
            },

            {
              type: "select",
              require: true,
              key: "Location",
              title: "Локация, где произошло несоответствие/инцидент",
              placeholder: "Не выбрано",
              condition: null,
              width: "w-full",
            },
            {
              type: "select",
              require: true,
              key: "Department",
              title: "Отдел, где произошло несоответствие/инцидент",
              placeholder: "Не выбрано",
              condition: null,
              width: "w-full",
            },
            {
              type: "select",
              require: true,
              key: "Region",
              title: "Участок, где произошло несоответствие/инцидент",
              placeholder: "Не выбрано",
              condition: null,
              width: "w-full",
            },
            {
              type: "textArea",
              key: "Description",
              require: true,
              title: "Описание",
              condition: null,
              noticeIcon: true,
              notice: `<span class="w-full"><strong>Что?</strong> (Что случилось, в чем именно проблема?)<br/>
            <strong>Где?</strong> (Где именно проблема в продукте/процессе и где была обнаружена?) <br/>
            <strong>Когда?</strong> (Когда проблема началась, когда была обнаружена?) <br/>
            <strong>Как?</strong> (Есть ли стандарт и соблюдался ли он на момент возникновения проблемы?) <br/>
            <strong>Кто?</strong> (Кто обнаружил проблему?) <br/>
            <strong>Насколько велика проблема?</strong> (Количество затронутого продукта / минуты простоя, риски от проблемы)<span>`,
              placeholder:
                "ЧТО? (Что случилось, в чем именно проблема?) ГДЕ? (Где именно проблема в продукте/процессе и где была обнаружена?) КОГДА? (Когда проблема началась, когда была обнаружена?) КАК? (Есть ли стандарт и соблюдался ли он на момент возникновения проблемы?) КТО? (Кто обнаружил проблему?) НАСКОЛЬКО ВЕЛИКА ПРОБЛЕМА? (Количество затронутого продукта / минуты простоя, риски от проблемы)",
              width: "w-full",
            },
          ],
        ];
        tempIncQuestions.forEach((item) => {
          if (item.Key !== "IncidentOption" && item.Key !== "QAIncidentType") {
            if (item.TypeQuestion === "select") {
              incFieldsForm = [
                ...incFieldsForm,
                {
                  type: item.TypeQuestion,
                  require: item.Require,
                  key: item.Key,
                  title: item.Title,
                  notice: item.Notice,
                  noticeIcon: (item.Notice && true) || false,
                  hide: item.DefaultHide,
                  width: item.Width,
                  placeholder: "Не выбрано",
                  condition: item.Condition && JSON.parse(item.Condition),
                  options:
                    (item.Options &&
                      item.Options.split(";").map((option) => {
                        return {
                          id: option.trim(),
                          name: option.trim(),
                        };
                      })) ||
                    [],
                },
              ];
            } else if (item.TypeQuestion === "radio" || item.TypeQuestion === "checkbox") {
              incFieldsForm = [
                ...incFieldsForm,
                {
                  type: item.TypeQuestion,
                  require: item.Require,
                  key: item.Key,
                  notice: item.Notice,
                  noticeIcon: (item.Notice && true) || false,
                  title: item.Title,
                  hide: item.DefaultHide,
                  width: item.Width,
                  condition: item.Condition && JSON.parse(item.Condition),
                  optionsInputs: (item.Options && item.Options.split(";").map((option) => option.trim())) || [],
                },
              ];
            } else if (
              item.TypeQuestion === "number" ||
              item.TypeQuestion === "input" ||
              item.TypeQuestion === "textArea"
            ) {
              incFieldsForm = [
                ...incFieldsForm,
                {
                  type: item.TypeQuestion,
                  require: item.Require,
                  key: item.Key,
                  title: item.Title,
                  disabled: item.Disabled,
                  placeholder: "Введите значение",
                  hide: item.DefaultHide,
                  width: item.Width,
                  notice: item.Notice,
                  noticeIcon: (item.Notice && true) || false,
                  condition: item.Condition && JSON.parse(item.Condition),
                  default: item.Options,
                },
              ];
            } else if (item.TypeQuestion === "repeater") {
              if (idCurrentTypeInc === incTypes.q) {
                //Качество
                incFieldsForm = [
                  ...incFieldsForm,
                  {
                    type: item.TypeQuestion,
                    key: item.Key,
                    hide: item.DefaultHide,
                    notice: item.Notice,
                    noticeIcon: (item.Notice && true) || false,
                    title: item.Title,
                    condition: item.Condition && JSON.parse(item.Condition),
                    fields: [
                      {
                        type: "autocomplete",
                        require: item.Require,
                        title: "SAP № технического места",
                        key: "SAP",
                        placeholder: "Начните вводить SAP",
                        width: item.Width,
                        searchApiField: "SAP",
                        searchApiList: equipmentsListName,
                        searchApiSelectFields: "ID,Title,SAP,Manufacturer,Model,TypeEquipment",
                        searchApiFilterField: "",
                        searchApiFilterFieldValue: "",
                      },
                      {
                        type: "text",
                        title: "Название оборудования",
                        key: "Title",
                        value: "",
                        require: item.Require,
                        width: item.Width,
                      },
                      {
                        type: "text",
                        title: "Производитель оборудования",
                        key: "Manufacturer",
                        value: "",
                        require: item.Require,
                        width: item.Width,
                      },
                      {
                        type: "text",
                        title: "Модель оборудования",
                        key: "Model",
                        value: "",
                        require: item.Require,
                        width: item.Width,
                      },
                      {
                        type: "text",
                        title: "Тип оборудования",
                        key: "TypeEquipment",
                        value: "",
                        require: item.Require,
                        width: item.Width,
                      },
                    ],
                    width: item.Width,
                    require: item.Require,
                  },
                ];
              }
              if (idCurrentTypeInc === incTypes.m) {
                //Техобслуживание
                incFieldsForm = [
                  ...incFieldsForm,
                  {
                    type: item.TypeQuestion,
                    key: item.Key,
                    hide: item.DefaultHide,
                    title: item.Title,
                    notice: item.Notice,
                    noticeIcon: (item.Notice && true) || false,
                    condition: item.Condition && JSON.parse(item.Condition),
                    fields: [
                      {
                        type: "input",
                        key: "SAP_MESSAGE",
                        require: item.Require,
                        title: "SAP номер сообщения",
                        placeholder: "Введите значение",
                        width: item.Width,
                      },
                      {
                        type: "autocomplete",
                        require: item.Require,
                        title: "SAP № технического места",
                        key: "SAP",
                        placeholder: "Начните вводить SAP",
                        width: item.Width,
                        searchApiField: "SAP",
                        searchApiList: equipmentsListName,
                        searchApiSelectFields: "ID,Title,SAP,Manufacturer,Model,TypeEquipment",
                        searchApiFilterField: "",
                        searchApiFilterFieldValue: "",
                      },
                      {
                        type: "text",
                        title: "Название оборудования",
                        key: "Title",
                        value: "",
                        require: item.Require,
                        width: item.Width,
                      },
                      {
                        type: "text",
                        title: "Производитель оборудования",
                        key: "Manufacturer",
                        value: "",
                        require: item.Require,
                        width: item.Width,
                      },
                      {
                        type: "text",
                        title: "Модель оборудования",
                        key: "Model",
                        value: "",
                        require: item.Require,
                        width: item.Width,
                      },
                      {
                        type: "text",
                        title: "Тип оборудования",
                        key: "TypeEquipment",
                        value: "",
                        require: item.Require,
                        width: item.Width,
                      },
                    ],
                    width: item.Width,
                    require: item.Require,
                  },
                ];
              }
            }
          }
        });
        setIncQuestions([...incFieldsForm]);
        setCustomLoading(false);
      });
    } else {
      setRenderInc(true);
    }
  }, [currentTypeInc, typesInc]);

  useEffect(() => {
    if (incidentID) {
      getItemsRequest({ listName: myTasksIncidentstListName, filters: { ID: incidentID } }).then(results => {
        if (results.items.length === 0) {
          alert("Карточка инцидента/несоответствия не найдена или удалена");
          query.delete("incidentCard");
          setQuery(query);
          return;
        } else {
          getItemsRequest({
            listName: myTasks5WayListName,
            filters: { Incident: incidentID },
          }).then((results) => {
            if (results.items.length > 0) {
              const card5WayID = results.items[0]["ID"];
              setID5Way(card5WayID);
              setCard5WayTree(
                (results.items[0].Tree && JSON.parse(results.items[0].Tree)) || []
              );
            }
            dispatch(
              getItem({
                listName: myTasksIncidentstListName,
                filters: { ID: incidentID },
              })
            );
          });
        }
      });
    }
  }, [incidentID, getInc]);

  useEffect(() => {
    if (incCard && Object.keys(incCard).length > 0 && !checkLoadUsers && Object.keys(users).length > 0) {
      console.log("incCard: ", incCard);
      if (incCard.AuthorEmail && incCard.ResponsibleEmail) {
        if (users[incCard.AuthorEmail] && users[incCard.ResponsibleEmail]) {
          setCheckLoadUsers(true);
        }
      }
      let tempDefaultValues: any = {};
      Object.keys(incCard).map((key: string, idx: number) => {
        const field = incCard[key];
        if (field && key === "Responsible") {
          tempDefaultValues[key] = [
            {
              label: (users[field.Email] && users[field.Email].displayName) || field.Name,
              value: (users[field.Email] && users[field.Email].email) || field.Email,
              avatar: (users[field.Email] && users[field.Email].avatar) || null,
              email: (users[field.Email] && users[field.Email].email) || field.Email,
            },
          ];
        } else if (key === "DateIncidents" || key === "DateIncidents2") {
          tempDefaultValues[key] = {
            startDate: field.toDate(),
            endDate: field.toDate(),
          };
        } else if (key === "Location" || key === "Department" || key === "Region" || key === "Status") {
          tempDefaultValues[key] = {
            id: field.ID,
            name: field.Title,
          };
        } else if (key === "AuthorEmail") {
          return false;
        } else if (key === "Questions") {
          if (field) {
            const incObj = JSON.parse(field);
            if (incObj) {
              tempDefaultValues = { ...tempDefaultValues, ...incObj };
            }
          }
        } else if (key === "TypeIncident") {
          tempDefaultValues[key] = field.Title;
          setCurrentTypeInc(field.Title);
        } else {
          tempDefaultValues[key] = field;
        }
      });
      setDefaultValues((prevState: any) => {
        return { ...prevState, ...tempDefaultValues };
      });
      setCurrentFormData({ ...tempDefaultValues });
    }
  }, [incCard, users, checkLoadUsers]);

  useEffect(() => {
    if (incCard && Object.keys(incCard).length > 0 && currentUser.id && renderInc && fields.length > 0) {
      const tempFieldsForm = [...fields];
      if (
        incCard.Status.ID === incStatus.finish ||
        incCard.Status.ID === incStatus.cancel ||
        (!currentUser.isAdmin &&
          (!currentUser.isLocationEditorMyTasks ||
            (currentUser.isLocationEditorMyTasks &&
              !currentUser.isLocationEditorMyTasks.some((locationID: number) => locationID === incCard.Location.ID))) &&
          (!currentUser.isLocationAdminMyTasks ||
            (currentUser.isLocationAdminMyTasks &&
              !currentUser.isLocationAdminMyTasks.some((locationID: number) => locationID === incCard.Location.ID))))
      ) {
        for (let i = 0; i < tempFieldsForm.length; i++) {
          tempFieldsForm[i]["disabled"] = true;
        }
      } else {
        for (let i = 0; i < tempFieldsForm.length; i++) {
          tempFieldsForm[i]["disabled"] = incQuestions[i]["disabled"];
        }
      }
      setFields([...tempFieldsForm]);
    }
  }, [incCard, currentUser, renderInc, dependenceFields]);

  useEffect(() => {
    if (renderInc && currentFormData) {
      const tempFieldsForm = [...fields];
      for (let i = 0; i < tempFieldsForm.length; i++) {
        const field = tempFieldsForm[i];
        if (field.condition) {
          let conditionObj: any = {};
          Object.keys(field.condition).map((key: string) => {
            if (typeof currentFormData[key] === "object") {
              if (currentFormData[key]["name"] === field.condition[key]) {
                conditionObj[key] = true;
              }
            } else {
              if (currentFormData[key] === field.condition[key]) {
                conditionObj[key] = true;
              }
            }
          });
          if (Object.keys(field.condition).length === Object.keys(conditionObj).length) {
            tempFieldsForm[i]["hide"] = false;
          } else {
            tempFieldsForm[i]["hide"] = true;
          }
        }
      }
      setFields([...tempFieldsForm]);
    }
  }, [currentFormData, renderInc]);

  const cancelHandle = () => {
    setCancelModal(false);
    setCustomLoading(true);
    updateItemRequest({ listName: myTasksIncidentstListName, body: { ID: incidentID, Status: incStatus.cancel } }).then((results) => {
      setCustomLoading(false);
      navigate(0);
    });
  };

  const returnToWorkHandle = (type: any) => {
    setReturnToWorkModal(false);
    setCustomLoading(true);
    updateItemRequest({ listName: myTasksIncidentstListName, body: { ID: incidentID, Status: incStatus.process } }).then((results) => {
      if (emailsSender && incCard.ResponsibleEmail !== currentUser.email && type === "Инцидент") {
        const timestamp = moment().unix();
        const emailBody = {
          Body: `Здравствуйте ${users[incCard.ResponsibleEmail] && users[incCard.ResponsibleEmail]["displayName"]
            },<br/><br/>Примите во внимание, что пользователь ${currentUser.displayName
            } вернул в работу инцидент <a href="${siteUrl}${urlDefault}/dashboard/3/incidents-and-nonconformities?incidentCardMobile=${incCard.ID
            }">${incCard.Title.trim()}</a>`,
          DateToBeSentAt: moment().subtract(12, "hours").toDate(),
          Title: "Мои Задачи | Возвращение в работу Инцидента",
          Subject: "Мои Задачи | Возвращение в работу Инцидента",
          Recepients: incCard.ResponsibleEmail,
          CheckDoc: String(timestamp),
        };
        Promise.all([sendEmail(emailBody)]).then(() => {
          setCustomLoading(false);
          navigate(0);
        });
      } else {
        setCustomLoading(false);
        navigate(0);
      }
    });
  };

  const invCompletedHandle = () => {
    setInvCompletedModal(false);
    setCustomLoading(true);
    updateItemRequest({ listName: myTasksIncidentstListName, body: { ID: incidentID, Status: incStatus.finish } }).then((results) => {
      if (emailsSender && incCard.ResponsibleEmail !== currentUser.email) {
        const timestamp = moment().unix();
        const emailBody = {
          Body: `Здравствуйте ${users[incCard.ResponsibleEmail] && users[incCard.ResponsibleEmail]["displayName"]
            },<br/><br/>Примите во внимание, что пользователь ${currentUser.displayName
            } завершил расследование инцидента <a href="${siteUrl}${urlDefault}/dashboard/3/incidents-and-nonconformities?incidentCardMobile=${incCard.ID
            }">${incCard.Title.trim()}</a>`,
          DateToBeSentAt: moment().subtract(12, "hours").toDate(),
          Title: "Мои Задачи | Прекращение расследования инцидента",
          Subject: "Мои Задачи | Прекращение расследования инцидента",
          Recepients: incCard.ResponsibleEmail,
          CheckDoc: String(timestamp),
        };
        Promise.all([sendEmail(emailBody)]).then(() => {
          setCustomLoading(false);
          navigate(0);
        });
      } else {
        setCustomLoading(false);
        navigate(0);
      }
    });
  };

  const importPPTXHandle = (typeDownload: string) => {
    if (incCard && Object.keys(incCard).length > 0) {
      if (typeDownload === "file") {
        setPptxLoading(true);
      } else {
        setLoadingEml(true);
      }
      const items = [incCard];
      const fontSize = 16;
      if (ID5Way) {
        getItemsRequest({ listName: myTasksSDCA5WayListName, filters: { _x0035_Way: ID5Way } }).then((results) => {
          const sdcaItems = [...results.items];
          let arrRequests: any = [];
          sdcaItems.map((item) => {
            arrRequests = [
              ...arrRequests,
              getItemsRequest({
                listName: myTaskActionsListName,
                filters: { ImportantHashTag: `#Отчет_об_отклонениях_${item.ID}*` },
              }),
            ];
          });
          Promise.all(arrRequests).then((values) => {
            let actions: any = [];
            values.map((value) => {
              actions = [...actions, ...value.items];
            });
            const returnItems = items.map((item: any) => {
              const currentSdcaItems = sdcaItems.filter(
                (sdcaItem: any) => sdcaItem._x0035_Way.get_lookupId() === ID5Way
              );
              let currentActions: any = [];
              let currentRootTree: any = [];
              currentSdcaItems.map((currentSdcaItem: any) => {
                currentActions = [
                  ...currentActions,
                  ...actions
                    .filter(
                      (action: any) =>
                        action.ImportantHashTag.indexOf(`#Отчет_об_отклонениях_${currentSdcaItem.ID}`) !== -1
                    )
                    .map((action: any) => {
                      return {
                        numRoot:
                          card5WayTree
                            .filter((treeItem: any) => treeItem.root)
                            .map((treeItem: any, idx: number) => {
                              if (treeItem.reason.trim() === currentSdcaItem.RootTree.trim()) {
                                return idx + 1;
                              } else {
                                return "";
                              }
                            })
                            .join("") || "-",
                        sdca: currentSdcaItem.SDCA.get_lookupValue(),
                        description: action.Description,
                        date: moment(action.DateForDone).format("DD.MM.YYYY"),
                        responsible: users[action.ResponsibleEmail]["displayName"],
                      };
                    }),
                ];
              });
              card5WayTree
                .filter((treeItem: any) => treeItem.root)
                .map((treeItem: any) => {
                  currentRootTree = [...currentRootTree, treeItem];
                });
              return {
                ...item,
                actions: currentActions,
                currentRootTree: (currentRootTree.length > 0 && currentRootTree) || [{ reason: "-" }],
              };
            });
            const Card5WayWithActions: any = returnItems[0];
            const pptx = new PptxGenJS();
            pptx.defineLayout({ name: "CUSTOM_LAYOUT", width: 22, height: 12.25 });
            pptx.layout = "CUSTOM_LAYOUT";
            let slide = pptx.addSlide();
            let rows: any = [];
            let rowHHeight = 1;
            let pptxTitle = "";
            let incCardQuestions: any = (incCard.Questions && JSON.parse(incCard.Questions)) || null;
            pptxTitle += `${incCardQuestions["IncidentOption"]}`;
            if (incCard.TypeIncident.ID === incTypes.safe) {
              pptxTitle += `  по безопасности`;
              rowHHeight = 5.4;
            }
            if (incCard.TypeIncident.ID === incTypes.e) {
              rowHHeight = 5.5;
              pptxTitle += ` по экологии`;
            }
            if (incCard.TypeIncident.ID === incTypes.q) {
              rowHHeight = 4.5;
              if (incCardQuestions.QAIncidentType === "Инцидент в процессе") {
                pptxTitle += ` в процессе`;
              }
              if (incCardQuestions.QAIncidentType === "Инцидент по качеству") {
                pptxTitle += ` по качеству`;
              }
            }
            if (incCard.TypeIncident.ID === incTypes.m) {
              rowHHeight = 4.8;
              pptxTitle += ` по техобслуживанию`;
            }
            rows.push([
              {
                text: `#${incCard.ID}`,
                options: {
                  align: "center",
                  color: "ffffff",
                  fill: "004465",
                  hyperlink: {
                    url: `${siteUrl}${urlDefault}/dashboard/3/incidents-and-nonconformities?incidentCardMobile=${incCard.ID}`,
                    color: "ffffff",
                  },
                },
              },
              {
                text: `${incCard.DateIncidents.format("DD.MM.YYYY")} ${incCard.TimeIncident || ""}`,
                options: {
                  align: "center",
                  color: "ffffff",
                  fill: "004465",
                  border: { type: "solid", color: "004465" },
                },
              },
              {
                text: `${pptxTitle}`.toUpperCase(),
                options: {
                  align: "center",
                  color: "ffffff",
                  fill: "004465",
                  border: { type: "solid", color: "004465" },
                },
              },
            ]);
            slide.addTable(rows, {
              colW: [3, 5, 14],
              w: 22,
              align: "center",
              rowH: 0.6,
              fontSize: fontSize,
              x: 0,
              y: 0,
              valign: "middle",
            });
            rows = [];
            rows.push([
              {
                text: "Локация",
                options: {
                  align: "center",
                  color: "ffffff",
                  fill: "00629B",
                  border: { type: "solid", color: "004465" },
                },
              },
              {
                text: "Описание",
                options: {
                  align: "center",
                  color: "ffffff",
                  fill: "00629B",
                  border: { type: "solid", color: "004465" },
                },
              },
              {
                text: "Корневые причины",
                options: {
                  align: "center",
                  color: "ffffff",
                  fill: "00629B",
                  border: { type: "solid", color: "004465" },
                },
              },
            ]);
            slide.addTable(rows, {
              colW: [10, 7, 5],
              w: 22,
              align: "center",
              rowH: 0.6,
              fontSize: fontSize,
              x: 0,
              y: 0.6,
              valign: "middle",
            });
            rows = [];
            rows.push([
              { text: "Локация: ", options: { bold: true, align: "left", border: { type: "solid", color: "004465" } } },
              { text: incCard.Location.Title, options: { align: "left", border: { type: "solid", color: "004465" } } },
            ]);
            rows.push([
              { text: "Отдел: ", options: { bold: true, align: "left", border: { type: "solid", color: "004465" } } },
              {
                text: incCard.Department.Title,
                options: { align: "left", border: { type: "solid", color: "004465" } },
              },
            ]);
            rows.push([
              { text: "Участок: ", options: { bold: true, align: "left", border: { type: "solid", color: "004465" } } },
              { text: incCard.Region.Title, options: { align: "left", border: { type: "solid", color: "004465" } } },
            ]);
            rows.push([
              {
                text: "ФИО инициатора: ",
                options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
              },
              {
                text: (users[incCard.AuthorEmail] && users[incCard.AuthorEmail]["displayName"]) || "-",
                options: { align: "left", border: { type: "solid", color: "004465" } },
              },
            ]);
            slide.addTable(rows, {
              colW: [4, 6],
              w: 10,
              align: "center",
              rowH: 0.6,
              fontSize: fontSize,
              x: 0,
              y: 1.2,
              valign: "middle",
            });
            rows = [];
            rows.push([
              {
                text: "Описание: ",
                options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
              },
              { text: incCard.Description, options: { align: "left", border: { type: "solid", color: "004465" } } },
            ]);
            slide.addTable(rows, {
              colW: [2, 5],
              w: 7,
              h: 4,
              align: "center",
              rowH: rowHHeight,
              fontSize: fontSize,
              x: 10,
              y: 1.2,
              valign: "top",
            });
            rows = [];
            Card5WayWithActions.currentRootTree.forEach((rootTree: any, idx: number) => {
              rows.push([
                { text: idx + 1, options: { bold: true, align: "left", border: { type: "solid", color: "004465" } } },
                { text: rootTree.reason, options: { align: "left", border: { type: "solid", color: "004465" } } },
              ]);
            });
            slide.addTable(rows, {
              colW: [1, 4],
              w: 5,
              h: 4,
              align: "center",
              rowH: rowHHeight / (Card5WayWithActions.currentRootTree.length || 1),
              fontSize: fontSize,
              x: 17,
              y: 1.2,
              valign: "top",
            });
            rows = [];
            rows.push([
              {
                text: (incCard.TypeIncident.ID === incTypes.q && "Сорт/Тип продукта/Объем") || "Классификация",
                options: {
                  align: "center",
                  color: "ffffff",
                  fill: "00629B",
                  border: { type: "solid", color: "004465" },
                },
              },
            ]);
            slide.addTable(rows, {
              colW: 10,
              w: 10,
              align: "center",
              rowH: 0.6,
              fontSize: fontSize,
              x: 0,
              y: 3.6,
              valign: "middle",
            });
            rows = [];
            if (incCard.TypeIncident.ID === incTypes.q) {
              rows.push([
                {
                  text: fields.find((field: any) => field.key === "QAIncidentTypeProduct" && !field.hide)["title"],
                  options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
                },
                {
                  text: incCardQuestions["QAIncidentTypeProduct"],
                  options: { align: "left", border: { type: "solid", color: "004465" } },
                },
              ]);
              if (incCard.Questions.indexOf("Инцидент в процессе") !== -1) {
                rows.push([
                  {
                    text: fields.find((field: any) => field.key === "QAIncidentListBlock" && !field.hide)["title"],
                    options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
                  },
                  {
                    text: incCardQuestions["QAIncidentListBlock"],
                    options: { align: "left", border: { type: "solid", color: "004465" } },
                  },
                ]);
              } else {
                rows.push([
                  {
                    text: fields.find((field: any) => field.key === "QAIncidentList" && !field.hide)["title"],
                    options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
                  },
                  {
                    text: incCardQuestions["QAIncidentList"],
                    options: { align: "left", border: { type: "solid", color: "004465" } },
                  },
                ]);
              }
            }
            if (incCard.TypeIncident.ID === incTypes.safe) {
              rows.push([
                {
                  text: fields.find((field: any) => field.key === "SafeIncClassification" && !field.hide)["title"],
                  options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
                },
                {
                  text:
                    (incCardQuestions["SafeIncClassification"] && incCardQuestions["SafeIncClassification"]["name"]) ||
                    "-",
                  options: { align: "left", border: { type: "solid", color: "004465" } },
                },
              ]);
              rows.push([
                {
                  text: fields.find((field: any) => field.key.indexOf("SafeIncTypeSIF") !== -1)["title"],
                  options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
                },
                {
                  text:
                    incCardQuestions[
                    Object.keys(incCardQuestions).find((key) => key.indexOf("SafeIncTypeSIF") !== -1)
                    ] || "-",
                  options: { align: "left", border: { type: "solid", color: "004465" } },
                },
              ]);
              rows.push([
                {
                  text: fields.find((field: any) => field.key.indexOf("SafeIncInjuryType") !== -1)["title"],
                  options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
                },
                {
                  text:
                    (Object.keys(incCardQuestions).find((key) => key.indexOf("SafeIncInjuryType") !== -1) &&
                      incCardQuestions[
                      Object.keys(incCardQuestions).find((key) => key.indexOf("SafeIncInjuryType") !== -1)
                      ]["name"]) ||
                    "-",
                  options: { align: "left", border: { type: "solid", color: "004465" } },
                },
              ]);
              rows.push([
                {
                  text: fields.find((field: any) => field.key === "SafeIncRiskSubcategory" && !field.hide)["title"],
                  options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
                },
                {
                  text:
                    (incCardQuestions["SafeIncRiskSubcategory"] &&
                      incCardQuestions["SafeIncRiskSubcategory"]["name"]) ||
                    "-",
                  options: { align: "left", border: { type: "solid", color: "004465" } },
                },
              ]);
            }
            if (incCard.TypeIncident.ID === incTypes.e) {
              rows.push([
                {
                  text: fields.find((field: any) => field.key === "EnvIncClassification" && !field.hide)["title"],
                  options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
                },
                {
                  text:
                    (incCardQuestions["EnvIncClassification"] && incCardQuestions["EnvIncClassification"]["name"]) ||
                    "-",
                  options: { align: "left", border: { type: "solid", color: "004465" } },
                },
              ]);
              rows.push([
                {
                  text: fields.find((field: any) => field.key === "EnvIncValueEnvironment" && !field.hide)["title"],
                  options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
                },
                {
                  text:
                    (incCardQuestions["EnvIncValueEnvironment"] &&
                      incCardQuestions["EnvIncValueEnvironment"].length > 0 &&
                      incCardQuestions["EnvIncValueEnvironment"].join(",")) ||
                    "-",
                  options: { align: "left", border: { type: "solid", color: "004465" } },
                },
              ]);
              rows.push([
                {
                  text: fields.find((field: any) => field.key === "EnvIncSIVRelated" && !field.hide)["title"],
                  options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
                },
                {
                  text: incCardQuestions["EnvIncSIVRelated"],
                  options: { align: "left", border: { type: "solid", color: "004465" } },
                },
              ]);
              rows.push([
                {
                  text: fields.find((field: any) => field.key === "EnvIncLegalReq" && !field.hide)["title"],
                  options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
                },
                {
                  text: incCardQuestions["EnvIncLegalReq"],
                  options: { align: "left", border: { type: "solid", color: "004465" } },
                },
              ]);
            }
            if (incCard.TypeIncident.ID === incTypes.m) {
              rows.push([
                {
                  text: fields.find((field: any) => field.key === "MIncCriteriaIncident")["title"],
                  options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
                },
                {
                  text:
                    (incCardQuestions.hasOwnProperty("MIncCriteriaIncident") &&
                      incCardQuestions["MIncCriteriaIncident"]) ||
                    "-",
                  options: { align: "left", border: { type: "solid", color: "004465" } },
                },
              ]);
              rows.push([
                {
                  text: fields.find((field: any) => field.key === "MIncDirection" && !field.hide)["title"],
                  options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
                },
                {
                  text: incCardQuestions["MIncDirection"]["name"] || "-",
                  options: { align: "left", border: { type: "solid", color: "004465" } },
                },
              ]);
              rows.push([
                {
                  text: fields.find((field: any) => field.key === "MIncReasonType" && !field.hide)["title"],
                  options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
                },
                {
                  text: incCardQuestions["MIncReasonType"]["name"] || "-",
                  options: { align: "left", border: { type: "solid", color: "004465" } },
                },
              ]);
              rows.push([
                {
                  text: fields.find((field: any) => field.key === "MIncDowntime" && !field.hide)["title"],
                  options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
                },
                {
                  text: incCardQuestions["MIncDowntime"],
                  options: { align: "left", border: { type: "solid", color: "004465" } },
                },
              ]);
              rows.push([
                {
                  text: fields.find((field: any) => field.key === "MIncEmergencyPurchaseCost" && !field.hide)["title"],
                  options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
                },
                {
                  text: incCardQuestions["MIncEmergencyPurchaseCost"],
                  options: { align: "left", border: { type: "solid", color: "004465" } },
                },
              ]);
              rows.push([
                {
                  text: fields.find((field: any) => field.key === "MIncTypeOfLostProduct" && !field.hide)["title"],
                  options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
                },
                {
                  text: incCardQuestions["MIncTypeOfLostProduct"]?.["name"] || "-",
                  options: { align: "left", border: { type: "solid", color: "004465" } },
                },
              ]);
              rows.push([
                {
                  text: fields.find((field: any) => field.key === "MIncQuantityOfLostProduct" && !field.hide)["title"],
                  options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
                },
                {
                  text: incCardQuestions["MIncQuantityOfLostProduct"],
                  options: { align: "left", border: { type: "solid", color: "004465" } },
                },
              ]);
            }
            slide.addTable(rows, {
              colW: [4, 6],
              w: 10,
              align: "center",
              rowH: 0.6,
              fontSize: fontSize,
              x: 0,
              y: 4.2,
              valign: "middle",
            });
            if (incCard.TypeIncident.ID === incTypes.m) {
              rows = [];
              rows.push([
                {
                  text: "Оборудование",
                  options: {
                    align: "center",
                    color: "ffffff",
                    fill: "00629B",
                    border: { type: "solid", color: "004465" },
                  },
                },
              ]);
              slide.addTable(rows, {
                colW: 12,
                w: 12,
                align: "center",
                rowH: 0.6,
                fontSize: fontSize,
                x: 10,
                y: rowHHeight + 1.2,
                valign: "middle",
              });
              rows = [];
              rows.push([
                {
                  text: "SAP номер сообщения",
                  options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
                },
                {
                  text: incCardQuestions["MIncEq"][0]["SAP_MESSAGE"] || "-",
                  options: { align: "left", border: { type: "solid", color: "004465" } },
                },
                {
                  text: "Производитель оборудования",
                  options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
                },
                {
                  text: incCardQuestions["MIncEq"][0]["SAP"]["Manufacturer"] || "-",
                  options: { align: "left", border: { type: "solid", color: "004465" } },
                },
              ]);
              rows.push([
                {
                  text: "SAP № технического места:",
                  options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
                },
                {
                  text: incCardQuestions["MIncEq"][0]["SAP"]["SAP"] || "-",
                  options: { align: "left", border: { type: "solid", color: "004465" } },
                },
                {
                  text: "Модель оборудования",
                  options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
                },
                {
                  text: incCardQuestions["MIncEq"][0]["SAP"]["Model"] || "-",
                  options: { align: "left", border: { type: "solid", color: "004465" } },
                },
              ]);
              rows.push([
                {
                  text: "Название оборудования:",
                  options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
                },
                {
                  text: incCardQuestions["MIncEq"][0]["SAP"]["Title"] || "-",
                  options: { align: "left", border: { type: "solid", color: "004465" } },
                },
                {
                  text: "Тип оборудования",
                  options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
                },
                {
                  text: incCardQuestions["MIncEq"][0]["SAP"]["TypeEquipment"] || "-",
                  options: { align: "left", border: { type: "solid", color: "004465" } },
                },
              ]);
              slide.addTable(rows, {
                colW: 3,
                w: 12,
                align: "center",
                rowH: 0.6,
                fontSize: fontSize,
                x: 10,
                y: rowHHeight + 1.8,
                valign: "middle",
              });
            }
            rows = [];
            rows.push([
              {
                text: "Фото",
                options: {
                  align: "center",
                  color: "ffffff",
                  fill: "00629B",
                  border: { type: "solid", color: "004465" },
                },
              },
              {
                text: "Действия",
                options: {
                  align: "center",
                  color: "ffffff",
                  fill: "00629B",
                  border: { type: "solid", color: "004465" },
                },
              },
            ]);
            slide.addTable(rows, {
              colW: [11, 11],
              w: 22,
              align: "center",
              rowH: 0.6,
              fontSize: fontSize,
              x: 0,
              y: (incCard.TypeIncident.ID === incTypes.m && rowHHeight + 3.6) || rowHHeight + 1.2,
              valign: "middle",
            });
            rows = [];
            if (Card5WayWithActions.actions.length > 0) {
              rows.push([
                { text: "№ Причины", options: { bold: true, align: "left" } },
                { text: "Описание", options: { bold: true, align: "left" } },
                { text: "Срок выполнения", options: { bold: true, align: "left" } },
              ]);
              Card5WayWithActions.actions.forEach((action: any) => {
                rows.push([
                  { text: action.numRoot, options: { align: "left" } },
                  { text: action.description, options: { align: "left" } },
                  { text: action.date, options: { align: "left" } },
                ]);
              });
              slide.addTable(rows, {
                colW: [2, 6, 3],
                x: 11,
                w: 11,
                y: (incCard.TypeIncident.ID === incTypes.m && rowHHeight + 4.2) || rowHHeight + 1.8,
                rowH: 0.6,
                fontSize: fontSize,
                border: { type: "solid", color: "004465" },
                valign: "middle",
              });
            }
            if (typeDownload === "file") {
              pptx.writeFile({ fileName: `${pptxTitle}_${incCard.ID}` }).then(() => {
                setPptxLoading(false);
              });
            }
            if (typeDownload === "letter") {
              pptx.write({ outputType: "blob" }).then((blob) => {
                const pptxFile = new File([blob], `${pptxTitle.replaceAll(" ", "_")}_${incCard.ID}.pptx`, {
                  type: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
                });
                setModalEml(true);
                setTimeout(() => {
                  const elem: any = document.querySelector("#eml_template_inc");
                  html2canvas(elem, {
                    useCORS: true,
                    allowTaint: true,
                  }).then(function (canvas) {
                    const urlScreen = canvas.toDataURL();
                    let QType: any = null;
                    if (incCard.TypeIncident.ID === incTypes.q && incCard.Questions.indexOf("Инцидент в процессе") !== -1) {
                      QType = "Инцидент в процессе";
                    }
                    if (incCard.TypeIncident.ID === incTypes.q && incCard.Questions.indexOf("Инцидент по качеству") !== -1) {
                      QType = "Инцидент по качеству";
                    }
                    getItemsRequest({
                      listName: myTasksIncidentCardRecipientsListName,
                      filters: { Location: incCard.Location.ID, TypeIncident: incCard.TypeIncident.ID, QType },
                      sortOrder: { name: "ID", desc: true },
                    }).then((results) => {
                      const emails = (results.items.length > 0 && results.items[0]["Recipients"]) || "";
                      const copies = (results.items.length > 0 && results.items[0]["Copies"]) || "";
                      const downloadOutlookFile = async () => {
                        try {
                          await downloadOutlookEmailWithAttachments({
                            from: { name: "Supplay Portal", email: "supplay.portal@abinbevefes.com" },
                            to:
                              (emails &&
                                emails.split(",").map((email: string) => {
                                  return {
                                    name: email.trim(),
                                    email: email.trim(),
                                  };
                                })) ||
                              [],
                            cc:
                              (copies &&
                                copies.split(",").map((email: string) => {
                                  return {
                                    name: email.trim(),
                                    email: email.trim(),
                                  };
                                })) ||
                              [],
                            subject:
                              (incCard.Status.ID === incStatus.finish && `Отчет об инциденте ${titleEmlPptx} - ${incCard.ID}`) ||
                              `Уведомление об инциденте ${titleEmlPptx} - ${incCard.ID}`,
                            htmlBody:
                              (incCard.Status.ID === incStatus.finish &&
                                `<p>Коллеги, здравствуйте! Во вложении отчет об <a href="${siteUrl}${urlDefault}/dashboard/3/incidents-and-nonconformities?incidentCardMobile=${incCard.ID}">инциденте ${titleEmlPptx} - ${incCard.ID}</a></p><br/><img src="${urlScreen}" alt=""><br/>`) ||
                              `<p>Коллеги, здравствуйте! Во вложении информация о случившемся <a href="${siteUrl}${urlDefault}/dashboard/3/incidents-and-nonconformities?incidentCardMobile=${incCard.ID}">инциденте ${titleEmlPptx} - ${incCard.ID}</a></p><br/><img src="${urlScreen}" alt=""><br/>`,
                            textBody: "",
                            attachments: [
                              {
                                name: `${pptxTitle.replaceAll(" ", "_")}_${incCard.ID}.pptx`,
                                content: pptxFile,
                                mimeType: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
                              },
                            ],
                            fileName: "inc_card_report.eml",
                          });
                        } catch (error) {
                          console.error("Ошибка:", error);
                        }
                      };
                      downloadOutlookFile().then(() => {
                        setLoadingEml(false);
                        setModalEml(false);
                      });
                    });
                  });
                }, 5000);
              });
            }
          });
        });
      } else {
        const returnItems = items.map((item: any) => {
          let currentActions: any = [];
          let currentRootTree: any = [];
          return {
            ...item,
            actions: currentActions,
            currentRootTree: (currentRootTree.length > 0 && currentRootTree) || [{ reason: "-" }],
          };
        });
        const Card5WayWithActions: any = returnItems[0];
        const pptx = new PptxGenJS();
        pptx.defineLayout({ name: "CUSTOM_LAYOUT", width: 22, height: 12.25 });
        pptx.layout = "CUSTOM_LAYOUT";
        let slide = pptx.addSlide();
        let rows: any = [];
        let rowHHeight = 1;
        let pptxTitle = "";
        let incCardQuestions = (incCard.Questions && JSON.parse(incCard.Questions)) || null;
        console.log("incCardQuestions: ", incCardQuestions);
        pptxTitle += `${incCardQuestions["IncidentOption"]}`;
        if (incCard.TypeIncident.ID === incTypes.safe) {
          pptxTitle += `  по безопасности`;
          rowHHeight = 5.4;
        }
        if (incCard.TypeIncident.ID === incTypes.e) {
          rowHHeight = 5.5;
          pptxTitle += ` по экологии`;
        }
        if (incCard.TypeIncident.ID === incTypes.q) {
          rowHHeight = 4.5;
          if (incCardQuestions.QAIncidentType === "Инцидент в процессе") {
            pptxTitle += ` в процессе`;
          }
          if (incCardQuestions.QAIncidentType === "Инцидент по качеству") {
            pptxTitle += ` по качеству`;
          }
        }
        if (incCard.TypeIncident.ID === incTypes.m) {
          rowHHeight = 4.8;
          pptxTitle += ` по техобслуживанию`;
        }
        rows.push([
          {
            text: `#${incCard.ID}`,
            options: {
              hyperlink: {
                url: `${siteUrl}${urlDefault}/dashboard/3/incidents-and-nonconformities?incidentCardMobile=${incCard.ID}`,
              },
              align: "center",
              color: "ffffff",
              fill: "004465",
            },
          },
          {
            text: `${incCard.DateIncidents.format("DD.MM.YYYY")} ${incCard.TimeIncident || ""}`,
            options: { align: "center", color: "ffffff", fill: "004465", border: { type: "solid", color: "004465" } },
          },
          {
            text: `${pptxTitle}`.toUpperCase(),
            options: { align: "center", color: "ffffff", fill: "004465", border: { type: "solid", color: "004465" } },
          },
        ]);
        slide.addTable(rows, {
          colW: [3, 5, 14],
          w: 22,
          align: "center",
          rowH: 0.6,
          fontSize: fontSize,
          x: 0,
          y: 0,
          valign: "middle",
        });
        rows = [];
        rows.push([
          {
            text: "Локация",
            options: { align: "center", color: "ffffff", fill: "00629B", border: { type: "solid", color: "004465" } },
          },
          {
            text: "Описание",
            options: { align: "center", color: "ffffff", fill: "00629B", border: { type: "solid", color: "004465" } },
          },
          {
            text: "Корневые причины",
            options: { align: "center", color: "ffffff", fill: "00629B", border: { type: "solid", color: "004465" } },
          },
        ]);
        slide.addTable(rows, {
          colW: [10, 7, 5],
          w: 22,
          align: "center",
          rowH: 0.6,
          fontSize: fontSize,
          x: 0,
          y: 0.6,
          valign: "middle",
        });
        rows = [];
        rows.push([
          { text: "Локация: ", options: { bold: true, align: "left", border: { type: "solid", color: "004465" } } },
          { text: incCard.Location.Title, options: { align: "left", border: { type: "solid", color: "004465" } } },
        ]);
        rows.push([
          { text: "Отдел: ", options: { bold: true, align: "left", border: { type: "solid", color: "004465" } } },
          { text: incCard.Department.Title, options: { align: "left", border: { type: "solid", color: "004465" } } },
        ]);
        rows.push([
          { text: "Участок: ", options: { bold: true, align: "left", border: { type: "solid", color: "004465" } } },
          { text: incCard.Region.Title, options: { align: "left", border: { type: "solid", color: "004465" } } },
        ]);
        rows.push([
          {
            text: "ФИО инициатора: ",
            options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
          },
          {
            text: (users[incCard.AuthorEmail] && users[incCard.AuthorEmail]["displayName"]) || "-",
            options: { align: "left", border: { type: "solid", color: "004465" } },
          },
        ]);
        slide.addTable(rows, {
          colW: [4, 6],
          w: 10,
          align: "center",
          rowH: 0.6,
          fontSize: fontSize,
          x: 0,
          y: 1.2,
          valign: "middle",
        });
        rows = [];
        rows.push([
          { text: "Описание: ", options: { bold: true, align: "left", border: { type: "solid", color: "004465" } } },
          { text: incCard.Description, options: { align: "left", border: { type: "solid", color: "004465" } } },
        ]);
        slide.addTable(rows, {
          colW: [2, 5],
          w: 7,
          h: 4,
          align: "center",
          rowH: rowHHeight,
          fontSize: fontSize,
          x: 10,
          y: 1.2,
          valign: "top",
        });
        rows = [];
        Card5WayWithActions.currentRootTree.forEach((rootTree: any, idx: number) => {
          rows.push([
            { text: idx + 1, options: { bold: true, align: "left", border: { type: "solid", color: "004465" } } },
            { text: rootTree.reason, options: { align: "left", border: { type: "solid", color: "004465" } } },
          ]);
        });
        slide.addTable(rows, {
          colW: [1, 4],
          w: 5,
          h: 4,
          align: "center",
          rowH: rowHHeight / (Card5WayWithActions.currentRootTree.length || 1),
          fontSize: fontSize,
          x: 17,
          y: 1.2,
          valign: "top",
        });
        rows = [];
        rows.push([
          {
            text: (incCard.TypeIncident.ID === incTypes.q && "Сорт/Тип продукта/Объем") || "Классификация",
            options: { align: "center", color: "ffffff", fill: "00629B", border: { type: "solid", color: "004465" } },
          },
        ]);
        slide.addTable(rows, {
          colW: 10,
          w: 10,
          align: "center",
          rowH: 0.6,
          fontSize: fontSize,
          x: 0,
          y: 3.6,
          valign: "middle",
        });
        rows = [];
        if (incCard.TypeIncident.ID === incTypes.q) {
          rows.push([
            {
              text: fields.find((field: any) => field.key === "QAIncidentTypeProduct" && !field.hide)["title"],
              options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
            },
            {
              text: incCardQuestions["QAIncidentTypeProduct"],
              options: { align: "left", border: { type: "solid", color: "004465" } },
            },
          ]);
          if (incCard.Questions.indexOf("Инцидент в процессе") !== -1) {
            rows.push([
              {
                text: fields.find((field: any) => field.key === "QAIncidentListBlock" && !field.hide)["title"],
                options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
              },
              {
                text: incCardQuestions["QAIncidentListBlock"],
                options: { align: "left", border: { type: "solid", color: "004465" } },
              },
            ]);
          } else {
            rows.push([
              {
                text: fields.find((field: any) => field.key === "QAIncidentList" && !field.hide)["title"],
                options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
              },
              {
                text: incCardQuestions["QAIncidentList"],
                options: { align: "left", border: { type: "solid", color: "004465" } },
              },
            ]);
          }
        }
        if (incCard.TypeIncident.ID === incTypes.safe) {
          rows.push([
            {
              text: fields.find((field: any) => field.key === "SafeIncClassification" && !field.hide)["title"],
              options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
            },
            {
              text:
                (incCardQuestions["SafeIncClassification"] && incCardQuestions["SafeIncClassification"]["name"]) || "-",
              options: { align: "left", border: { type: "solid", color: "004465" } },
            },
          ]);
          rows.push([
            {
              text: fields.find((field: any) => field.key.indexOf("SafeIncTypeSIF") !== -1)["title"],
              options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
            },
            {
              text:
                incCardQuestions[Object.keys(incCardQuestions).find((key) => key.indexOf("SafeIncTypeSIF") !== -1)] ||
                "-",
              options: { align: "left", border: { type: "solid", color: "004465" } },
            },
          ]);
          rows.push([
            {
              text: fields.find((field: any) => field.key.indexOf("SafeIncInjuryType") !== -1)["title"],
              options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
            },
            {
              text:
                (Object.keys(incCardQuestions).find((key) => key.indexOf("SafeIncInjuryType") !== -1) &&
                  incCardQuestions[
                  Object.keys(incCardQuestions).find((key) => key.indexOf("SafeIncInjuryType") !== -1)
                  ]["name"]) ||
                "-",
              options: { align: "left", border: { type: "solid", color: "004465" } },
            },
          ]);
          rows.push([
            {
              text: fields.find((field: any) => field.key === "SafeIncRiskSubcategory" && !field.hide)["title"],
              options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
            },
            {
              text:
                (incCardQuestions["SafeIncRiskSubcategory"] && incCardQuestions["SafeIncRiskSubcategory"]["name"]) ||
                "-",
              options: { align: "left", border: { type: "solid", color: "004465" } },
            },
          ]);
        }
        if (incCard.TypeIncident.ID === incTypes.e) {
          rows.push([
            {
              text: fields.find((field: any) => field.key === "EnvIncClassification" && !field.hide)["title"],
              options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
            },
            {
              text:
                (incCardQuestions["EnvIncClassification"] && incCardQuestions["EnvIncClassification"]["name"]) || "-",
              options: { align: "left", border: { type: "solid", color: "004465" } },
            },
          ]);
          rows.push([
            {
              text: fields.find((field: any) => field.key === "EnvIncValueEnvironment" && !field.hide)["title"],
              options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
            },
            {
              text:
                (incCardQuestions["EnvIncValueEnvironment"] &&
                  incCardQuestions["EnvIncValueEnvironment"].length > 0 &&
                  incCardQuestions["EnvIncValueEnvironment"].join(",")) ||
                "-",
              options: { align: "left", border: { type: "solid", color: "004465" } },
            },
          ]);
          rows.push([
            {
              text: fields.find((field: any) => field.key === "EnvIncSIVRelated" && !field.hide)["title"],
              options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
            },
            {
              text: incCardQuestions["EnvIncSIVRelated"],
              options: { align: "left", border: { type: "solid", color: "004465" } },
            },
          ]);
          rows.push([
            {
              text: fields.find((field: any) => field.key === "EnvIncLegalReq" && !field.hide)["title"],
              options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
            },
            {
              text: incCardQuestions["EnvIncLegalReq"],
              options: { align: "left", border: { type: "solid", color: "004465" } },
            },
          ]);
        }
        if (incCard.TypeIncident.ID === incTypes.m) {
          rows.push([
            {
              text: fields.find((field: any) => field.key === "MIncCriteriaIncident")["title"],
              options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
            },
            {
              text:
                (incCardQuestions.hasOwnProperty("MIncCriteriaIncident") && incCardQuestions["MIncCriteriaIncident"]) ||
                "-",
              options: { align: "left", border: { type: "solid", color: "004465" } },
            },
          ]);
          rows.push([
            {
              text: fields.find((field: any) => field.key === "MIncDirection" && !field.hide)["title"],
              options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
            },
            {
              text: (incCardQuestions["MIncDirection"] && incCardQuestions["MIncDirection"]["name"]) || "-",
              options: { align: "left", border: { type: "solid", color: "004465" } },
            },
          ]);
          rows.push([
            {
              text: fields.find((field: any) => field.key === "MIncReasonType" && !field.hide)["title"],
              options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
            },
            {
              text: (incCardQuestions["MIncReasonType"] && incCardQuestions["MIncReasonType"]["name"]) || "-",
              options: { align: "left", border: { type: "solid", color: "004465" } },
            },
          ]);
          rows.push([
            {
              text: fields.find((field: any) => field.key === "MIncDowntime" && !field.hide)["title"],
              options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
            },
            {
              text: incCardQuestions["MIncDowntime"],
              options: { align: "left", border: { type: "solid", color: "004465" } },
            },
          ]);
          rows.push([
            {
              text: fields.find((field: any) => field.key === "MIncEmergencyPurchaseCost" && !field.hide)["title"],
              options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
            },
            {
              text: incCardQuestions["MIncEmergencyPurchaseCost"],
              options: { align: "left", border: { type: "solid", color: "004465" } },
            },
          ]);
          rows.push([
            {
              text: fields.find((field: any) => field.key === "MIncTypeOfLostProduct" && !field.hide)["title"],
              options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
            },
            {
              text:
                (incCardQuestions["MIncTypeOfLostProduct"] && incCardQuestions["MIncTypeOfLostProduct"]["name"]) || "-",
              options: { align: "left", border: { type: "solid", color: "004465" } },
            },
          ]);
          rows.push([
            {
              text: fields.find((field: any) => field.key === "MIncQuantityOfLostProduct" && !field.hide)["title"],
              options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
            },
            {
              text: incCardQuestions["MIncQuantityOfLostProduct"],
              options: { align: "left", border: { type: "solid", color: "004465" } },
            },
          ]);
        }
        slide.addTable(rows, {
          colW: [4, 6],
          w: 10,
          align: "center",
          rowH: 0.6,
          fontSize: fontSize,
          x: 0,
          y: 4.2,
          valign: "middle",
        });
        if (incCard.TypeIncident.ID === incTypes.m) {
          rows = [];
          rows.push([
            {
              text: "Оборудование",
              options: { align: "center", color: "ffffff", fill: "00629B", border: { type: "solid", color: "004465" } },
            },
          ]);
          slide.addTable(rows, {
            colW: 12,
            w: 12,
            align: "center",
            rowH: 0.6,
            fontSize: fontSize,
            x: 10,
            y: rowHHeight + 1.2,
            valign: "middle",
          });
          rows = [];
          rows.push([
            {
              text: "SAP номер сообщения",
              options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
            },
            {
              text: incCardQuestions["MIncEq"][0]["SAP_MESSAGE"] || "-",
              options: { align: "left", border: { type: "solid", color: "004465" } },
            },
            {
              text: "Производитель оборудования",
              options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
            },
            {
              text: incCardQuestions["MIncEq"][0]["SAP"]["Manufacturer"] || "-",
              options: { align: "left", border: { type: "solid", color: "004465" } },
            },
          ]);
          rows.push([
            {
              text: "SAP № технического места:",
              options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
            },
            {
              text: incCardQuestions["MIncEq"][0]["SAP"]["SAP"] || "-",
              options: { align: "left", border: { type: "solid", color: "004465" } },
            },
            {
              text: "Модель оборудования:",
              options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
            },
            {
              text: incCardQuestions["MIncEq"][0]["SAP"]["Model"] || "-",
              options: { align: "left", border: { type: "solid", color: "004465" } },
            },
          ]);
          rows.push([
            {
              text: "Название оборудования:",
              options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
            },
            {
              text: incCardQuestions["MIncEq"][0]["SAP"]["Title"] || "-",
              options: { align: "left", border: { type: "solid", color: "004465" } },
            },
            {
              text: "Тип оборудования",
              options: { bold: true, align: "left", border: { type: "solid", color: "004465" } },
            },
            {
              text: incCardQuestions["MIncEq"][0]["SAP"]["TypeEquipment"] || "-",
              options: { align: "left", border: { type: "solid", color: "004465" } },
            },
          ]);
          slide.addTable(rows, {
            colW: 3,
            w: 12,
            align: "center",
            rowH: 0.6,
            fontSize: fontSize,
            x: 10,
            y: rowHHeight + 1.8,
            valign: "middle",
          });
        }
        rows = [];
        rows.push([
          {
            text: "Фото",
            options: { align: "center", color: "ffffff", fill: "00629B", border: { type: "solid", color: "004465" } },
          },
          {
            text: "Действия",
            options: { align: "center", color: "ffffff", fill: "00629B", border: { type: "solid", color: "004465" } },
          },
        ]);
        slide.addTable(rows, {
          colW: [11, 11],
          w: 22,
          align: "center",
          rowH: 0.6,
          fontSize: fontSize,
          x: 0,
          y: (incCard.TypeIncident.ID === incTypes.m && rowHHeight + 3.6) || rowHHeight + 1.2,
          valign: "middle",
        });
        if (typeDownload === "file") {
          pptx.writeFile({ fileName: `${pptxTitle}_${incCard.ID}` }).then(() => {
            setPptxLoading(false);
          });
        }
        if (typeDownload === "letter") {
          pptx.write({ outputType: "blob" }).then((blob) => {
            const pptxFile = new File([blob], `${pptxTitle.replaceAll(" ", "_")}_${incCard.ID}.pptx`, {
              type: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
            });
            setModalEml(true);
            setTimeout(() => {
              const elem: any = document.querySelector("#eml_template_inc");
              html2canvas(elem, {
                useCORS: true,
                allowTaint: true,
              }).then(function (canvas) {
                const urlScreen = canvas.toDataURL();
                let QType: any = null;
                if (incCard.TypeIncident.ID === incTypes.q && incCard.Questions.indexOf("Инцидент в процессе") !== -1) {
                  QType = "Инцидент в процессе";
                }
                if (incCard.TypeIncident.ID === incTypes.q && incCard.Questions.indexOf("Инцидент по качеству") !== -1) {
                  QType = "Инцидент по качеству";
                }
                getItemsRequest({
                  listName: myTasksIncidentCardRecipientsListName,
                  filters: { Location: incCard.Location.ID, TypeIncident: incCard.TypeIncident.ID, QType },
                  sortOrder: { name: "ID", desc: true },
                }).then((results) => {
                  const emails = (results.items.length > 0 && results.items[0]["Recipients"]) || "";
                  const copies = (results.items.length > 0 && results.items[0]["Copies"]) || "";
                  const downloadOutlookFile = async () => {
                    try {
                      await downloadOutlookEmailWithAttachments({
                        from: { name: "Supplay Portal", email: "supplay.portal@abinbevefes.com" },
                        to:
                          (emails &&
                            emails.split(",").map((email: string) => {
                              return {
                                name: email.trim(),
                                email: email.trim(),
                              };
                            })) ||
                          [],
                        cc:
                          (copies &&
                            copies.split(",").map((email: string) => {
                              return {
                                name: email.trim(),
                                email: email.trim(),
                              };
                            })) ||
                          [],
                        subject:
                          (incCard.Status.ID === incStatus.finish && `Отчет об инциденте ${titleEmlPptx} - ${incCard.ID}`) ||
                          `Уведомление об инциденте ${titleEmlPptx} - ${incCard.ID}`,
                        htmlBody:
                          (incCard.Status.ID === incStatus.finish &&
                            `<p>Коллеги, здравствуйте! Во вложении отчет об <a href="${siteUrl}${urlDefault}/dashboard/3/incidents-and-nonconformities?incidentCardMobile=${incCard.ID}">инциденте ${titleEmlPptx} - ${incCard.ID}</a></p><br/><img src="${urlScreen}" alt=""><br/>`) ||
                          `<p>Коллеги, здравствуйте! Во вложении информация о случившемся <a href="${siteUrl}${urlDefault}/dashboard/3/incidents-and-nonconformities?incidentCardMobile=${incCard.ID}">инциденте ${titleEmlPptx} - ${incCard.ID}</a></p><br/><img src="${urlScreen}" alt=""><br/>`,
                        textBody: "",
                        attachments: [
                          {
                            name: `${pptxTitle.replaceAll(" ", "_")}_${incCard.ID}.pptx`,
                            content: pptxFile,
                            mimeType: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
                          },
                        ],
                        fileName: "inc_card_report.eml",
                      });
                    } catch (error) {
                      console.error("Ошибка:", error);
                    }
                  };
                  downloadOutlookFile().then(() => {
                    setLoadingEml(false);
                    setModalEml(false);
                  });
                });
              });
            }, 5000);
          });
        }
      }
    }
  };

  useEffect(() => {
    setLoadingEml(true);
    if (incCard && Object.keys(incCard).length > 0) {
      let incCardQuestions = (incCard.Questions && JSON.parse(incCard.Questions)) || null;
      setIncCardQuestionsEml(incCardQuestions);
      if (incCard.TypeIncident.ID === incTypes.safe) {
        setTitleEmlPptx("по безопасности");
      }
      if (incCard.TypeIncident.ID === incTypes.e) {
        setTitleEmlPptx("по экологии");
      }
      if (incCard.TypeIncident.ID === incTypes.q) {
        if (incCardQuestions.QAIncidentType === "Инцидент в процессе") {
          setTitleEmlPptx("в процессе");
        }
        if (incCardQuestions.QAIncidentType === "Инцидент по качеству") {
          setTitleEmlPptx("по качеству");
        }
      }
      if (incCard.TypeIncident.ID === incTypes.m) {
        setTitleEmlPptx("по техобслуживанию");
      }
      if (ID5Way) {
        getItemsRequest({ listName: myTasksSDCA5WayListName, filters: { _x0035_Way: ID5Way } })
          .then((results) => {
            const sdcaItems = [...results.items];
            let arrRequests: any = [];
            sdcaItems.map((item) => {
              arrRequests = [
                ...arrRequests,
                getItemsRequest({
                  listName: myTaskActionsListName,
                  filters: { ImportantHashTag: `#Отчет_об_отклонениях_${item.ID}*` },
                }),
              ];
            });
            if (arrRequests.length > 0) {
              Promise.all(arrRequests)
                .then((values) => {
                  let actions: any = [];
                  values.map((value) => {
                    actions = [...actions, ...value.items];
                    const currentSdcaItems = sdcaItems.filter(
                      (sdcaItem: any) => sdcaItem._x0035_Way.get_lookupId() === ID5Way
                    );
                    let currentActions: any = [];
                    currentSdcaItems.map((currentSdcaItem: any) => {
                      currentActions = [
                        ...currentActions,
                        ...actions
                          .filter(
                            (action: any) =>
                              action.ImportantHashTag.indexOf(`#Отчет_об_отклонениях_${currentSdcaItem.ID}`) !== -1
                          )
                          .map((action: any, idx: number) => {
                            return {
                              idx: idx + 1,
                              description: action.Description,
                              date: moment(action.DateForDone).format("DD.MM.YYYY"),
                            };
                          }),
                      ];
                    });
                    setActionsEml([...currentActions]);
                    setLoadingEml(false);
                  });
                })
                .catch((error) => {
                  console.error("Ошибка:", error);
                  setLoadingEml(false);
                });
            } else {
              setLoadingEml(false);
            }
          })
          .catch((error) => {
            console.error("Ошибка:", error);
            setLoadingEml(false);
          });
      } else {
        setLoadingEml(false);
      }
    } else if (incCardStatus === "SUCCESS") {
      setLoadingEml(false);
    }
  }, [incCard, ID5Way]);

  useEffect(() => {
      if (incCard && Object.keys(incCard).length > 0 && currentUser.email && !incCard.View && incCard.ResponsibleEmail.indexOf(currentUser.email) !== -1) {
        setCustomLoading(true);
        updateItemRequest({ listName: myTasksIncidentstListName, body: { ID: incCard.ID, View: true } }).then(() => {
          setCustomLoading(false);
        })
      }
    }, [incCard, currentUser]);

  return (
    <>
      <DrawerComponent zIndex={zIndex} open={open} toggleDrawer={setOpen}>
        <div className="flex flex-col p-[24px] shrink">
          {customLoading && <LoadingOpBg />}
          {incCard && Object.keys(incCard).length > 0 && (
            <>
              <FlexRow className="relative justify-between gap-5 mb-4">
                <h1 className="mb-4 text-black relative break-words z-[3] leading-none flex items-center justify-between w-full">
                  <span className="line-clamp-2 text-[16px] flex-1">{incCard.Title}</span>
                  <ClosePanelBtnMobile toggleDrawer={setOpen} hideXMarkIcon={false} />
                </h1>
                <FlexRow className="gap-[10px] right-0 top-0 z-[5] hidden">
                  {<Statuses incidentID={incidentID} />}
                  {JSON.parse(incCard.Questions)["IncidentOption"] === "Инцидент" && (
                    <>
                      {((loadingEml || statusUsers === "LOADING") && (
                        <FlexCol className="h-[32px] w-[32px]">
                          <Loading />
                        </FlexCol>
                      )) || (
                          <TooltipItem
                            position="top-left"
                            tooltipsText={
                              (incCard.Status.ID === incStatus.finish && "Скачать письмо о результатах расследования инцидента") ||
                              "Скачать письмо о случившемся инциденте"
                            }
                          >
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                importPPTXHandle("letter");
                              }}
                              className="flex w-6 h-6 text-[#9CA3AF] hover:text-[#012169]"
                            >
                              <Letter />
                            </a>
                          </TooltipItem>
                        )}
                      {((pptxLoading || statusUsers === "LOADING") && (
                        <FlexCol className="h-[32px] w-[32px]">
                          <Loading />
                        </FlexCol>
                      )) || (
                          <TooltipItem position="top-left" tooltipsText="Скачать в Power Point">
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                importPPTXHandle("file");
                              }}
                              className="flex w-6 h-6 text-[#9CA3AF] hover:text-[#012169]"
                            >
                              <DownloadWithHoverIcon />
                            </a>
                          </TooltipItem>
                        )}
                    </>
                  )}
                  {/* {incCard.Status.ID !== 4 && (
                    <TooltipItem
                      position="top-left"
                      tooltipsText={
                        (JSON.parse(incCard.Questions)["IncidentOption"] === "Несоответствие" &&
                          "Отменить несоответствие") ||
                        "Отменить инцидент"
                      }
                    >
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          setCancelModal(true);
                        }}
                        className="flex w-6 h-6 text-[#9CA3AF] hover:text-[#012169]"
                      >
                        <CancelIcon />
                      </a>
                    </TooltipItem>
                  )} */}
                </FlexRow>
              </FlexRow>
              {incCard.Status.ID === 17 && incCard.UserFinished &&
                <div className="w-[calc(100%+48px)] border-t border-b mx-[-24px] bg-white border-[#DFE4EA]">
                  <div className="px-[24px] py-4">
                    <span className="font-medium mb-2 block text-sm text-[#F89090]">Этот инцидент завершил(а):</span>
                    <div className="flex gap-[5px]">
                      <UserAvatar
                          avatar={users[incCard.UserFinished] && users[incCard.UserFinished].avatar}
                          shortName={users[incCard.UserFinished] && users[incCard.UserFinished]['shortName']}
                          displayName={users[incCard.UserFinished] && users[incCard.UserFinished].displayName}
                          email={incCard.UserFinished}
                      />
                      <FlexCol className="justify-center items-start">
                        <span className="text-[#111928]">{users[incCard.UserFinished] && users[incCard.UserFinished].displayName}</span>
                        {incCard.DateFinished && <span className="text-sm text-[#637381]">{incCard.DateFinished.format('DD.MM.YYYY')}</span>}
                      </FlexCol>
                    </div>
                  </div>
                </div>
              }
              {/*<div>test123</div>*/}
              <Form
                type="inc_card_my_tasks"
                setFormData={setFormData}
                setCurrentTypeInc={setCurrentTypeInc}
                setCurrentFormData={setCurrentFormData}
                fieldsForm={[...fields]}
                defaultValues={defaultValues}
                setCard5WayTree={setCard5WayTree}
                setDependenceFields={setDependenceFields}
                incidentID={incidentID}
                card5WayTree={card5WayTree}
                ID5WayAdd={ID5Way}
                incLoading={customLoading}
                setInvCompletedModal={setInvCompletedModal}
                incCard={incCard}
                isMobileIncCard={true}
              />
              {(incCard.Status.ID === incStatus.finish || incCard.Status.ID === incStatus.cancel) && (
                <FlexRow className="justify-between w-full gap-5">
                  <Button classBg="btn-white" shadow={true} text="Закрыть" open={open} setOpen={setOpen} />
                  {(currentUser.isAdmin ||
                    (currentUser.isDirecor &&
                      currentUser.isLocationEditorMyTasks &&
                      currentUser.isLocationEditorMyTasks.length > 0 &&
                      currentUser.isLocationEditorMyTasks.find(
                        (locationID: any) => locationID === incCard.Location.ID
                      )) ||
                    (currentUser.isDirecor &&
                      currentUser.isLocationAdminMyTasks &&
                      currentUser.isLocationAdminMyTasks.length > 0 &&
                      currentUser.isLocationAdminMyTasks.find(
                        (locationID: any) => locationID === incCard.Location.ID
                      ))) && (
                      <Button
                        open={returnToWorkModal}
                        setOpen={setReturnToWorkModal}
                        classBg="btn-dark"
                        icon={true}
                        typeIcon="return"
                        shadow={true}
                        text="Вернуть в работу"
                      />
                    )}
                </FlexRow>
              )}
            </>
          )}
        </div>
      </DrawerComponent>
      <Modal
        zIndex={zIndex ? zIndex + 10 : 70}
        modalClassName="min-h-px"
        open={cancelModal}
        toggleDialog={setCancelModal}
      >
        <header className="px-10 pb-4">
          <h2>Подтвердите действие</h2>
        </header>

        <div className="px-10 py-5">
          {(incCard &&
            Object.keys(incCard).length > 0 &&
            JSON.parse(incCard.Questions)["IncidentOption"] === "Несоответствие" && (
              <p>Вы уверены, что хотите отменить несоответствие?</p>
            )) || <p>Вы уверены, что хотите отменить инцидент?</p>}
        </div>
        <footer className="flex flex-col gap-2 w-full px-10 pt-10 mt-4 border-t">
          <TGButton color="white" onClick={(e) => setCancelModal(!cancelModal)}>
            Не отменять
          </TGButton>
          <TGButton color="bluedark" onClick={cancelHandle}>
            Да, отменить
          </TGButton>
        </footer>
      </Modal>
      <Modal
        zIndex={zIndex ? zIndex + 10 : 70}
        modalClassName="min-h-px"
        open={returnToWorkModal}
        toggleDialog={setReturnToWorkModal}
      >
        <header className="px-10 pb-4">
          <h2>Подтвердите действие</h2>
        </header>
        <div className="px-10 py-5">
          {(incCard &&
            Object.keys(incCard).length > 0 &&
            JSON.parse(incCard.Questions)["IncidentOption"] === "Несоответствие" && (
              <p>Вы уверены, что хотите вернуть в работу несоответствие?</p>
            )) || <p>Вы уверены, что хотите вернуть в работу инцидент?</p>}
        </div>
        <footer className="flex flex-col gap-2 w-full px-10 pt-10 mt-4 border-t">
          <TGButton color="white" onClick={(e) => setReturnToWorkModal(!returnToWorkModal)}>
            Не возвращать
          </TGButton>
          <TGButton
            color="bluedark"
            onClick={(e) =>
              returnToWorkHandle(
                incCard && Object.keys(incCard).length > 0 && JSON.parse(incCard.Questions)["IncidentOption"]
              )
            }
          >
            Да, вернуть
          </TGButton>
        </footer>
      </Modal>
      <Modal
        zIndex={zIndex ? zIndex + 10 : 70}
        modalClassName="min-h-px"
        open={invCompletedModal}
        toggleDialog={setInvCompletedModal}
      >
        <header className="px-10 pb-4">
          <h2>Подтвердите действие</h2>
        </header>

        <div className="px-10 py-5">
          <p>Завершить расследование инцидента?</p>
        </div>
        <footer className="flex flex-col gap-2 w-full px-10 pt-10 mt-4 border-t">
          <TGButton color="white" onClick={(e) => setInvCompletedModal(!invCompletedModal)}>
            Отмена
          </TGButton>
          <TGButton color="bluedark" onClick={invCompletedHandle}>
            Да, завершить
          </TGButton>
        </footer>
      </Modal>
      <Modal zIndex={zIndex ? zIndex + 10 : 70} modalClassName="min-h-px" open={modalEml} toggleDialog={setModalEml}>
        <FlexCol className="items-center justify-center w-full">
          <span className="block mb-5 text-base text-darkblue">Формируем письмо...</span>
          <Loading />
        </FlexCol>
        {incCard && Object.keys(incCard).length > 0 && incCardQuestionsEml && fields.length > 0 && (
          <FlexCol className="p-[25px] overflow-auto scrollbar scrollbar-thumb-rounded-lg scrollbar-h-2 scrollbar-w-2 scrollbar-thumb-[#D1D5DB] max-w-[700px] h-[350px]">
            <FlexCol id="eml_template_inc" className="border border-[#004465] min-w-[1920px]">
              <FlexRow className="w-full bg-[#004465] text-[#FFFFFF] min-h-[45px] break-all items-center">
                <FlexCol className="w-[15%] items-center justify-center mb-5 min-h-[45px] break-all">
                  № {incCard.ID}
                </FlexCol>
                <FlexCol className="w-[15%] items-center justify-center mb-5 min-h-[45px] break-all">{`${incCard.DateIncidents.format(
                  "DD.MM.YYYY"
                )} ${incCard.TimeIncident || ""}`}</FlexCol>
                <FlexCol className="w-[70%] items-center justify-center mb-5 min-h-[45px] break-all">
                  Инцидент {titleEmlPptx}
                </FlexCol>
              </FlexRow>
              <FlexRow className="w-full bg-[#00629B] text-[#FFFFFF] min-h-[45px] break-all items-center justify-between">
                <FlexCol className="w-[33%] items-center justify-center mb-5 min-h-[45px] break-all">Локация</FlexCol>
                <FlexCol className="w-[33%] items-center justify-center mb-5 min-h-[45px] break-all">Описание</FlexCol>
                <FlexCol className="w-[33%] items-center justify-center mb-5 min-h-[45px] break-all">
                  Корневые причины
                </FlexCol>
              </FlexRow>
              <FlexRow className="w-full">
                <FlexCol className="w-[30%]">
                  <FlexCol className="border-r border-[#004465] w-full px-2 pb-5">
                    <div className="min-h-[45px] break-all flex items-center">
                      <span className="w-[50%]">
                        <strong>Локация:</strong>
                      </span>{" "}
                      <span className="w-[50%]">{incCard.Location.Title}</span>
                    </div>
                    <div className="min-h-[45px] break-all flex items-center">
                      <span className="w-[50%]">
                        <strong>Отдел:</strong>
                      </span>{" "}
                      <span className="w-[50%]">{incCard.Department.Title}</span>
                    </div>
                    <div className="min-h-[45px] break-all flex items-center">
                      <span className="w-[50%]">
                        <strong>Участок:</strong>
                      </span>{" "}
                      <span className="w-[50%]">{incCard.Region.Title}</span>
                    </div>
                    <div className="min-h-[45px] break-all flex items-center">
                      <span className="w-[50%]">
                        <strong>Ответственный:</strong>
                      </span>{" "}
                      <span className="w-[50%]">
                        {(users[incCard.AuthorEmail] && users[incCard.AuthorEmail]["displayName"]) || "-"}
                      </span>
                    </div>
                  </FlexCol>
                  <FlexRow className="w-full min-h-[45px] break-all text-[#FFFFFF] items-center">
                    <FlexCol className="border-r border-[#004465] w-full bg-[#00629B] text-[#FFFFFF] justify-center items-center min-h-[45px] break-all pb-5">
                      {(incCard.TypeIncident.ID === incTypes.q && "Сорт/Тип продукта/Объем") || "Классификация"}
                    </FlexCol>
                  </FlexRow>
                  {incCard.TypeIncident.ID === incTypes.q && (
                    <FlexCol className="border-r border-[#004465] px-2 gap-2 pb-5">
                      <div className="min-h-[45px] break-all flex gap-2">
                        <span className="w-[50%]">
                          <strong>
                            {fields.find((field: any) => field.key === "QAIncidentTypeProduct" && !field.hide) &&
                              fields.find((field: any) => field.key === "QAIncidentTypeProduct" && !field.hide)[
                              "title"
                              ]}
                            :
                          </strong>
                        </span>{" "}
                        <span className="w-[50%]">{incCardQuestionsEml["QAIncidentTypeProduct"]}</span>
                      </div>
                      {(incCard.Questions.indexOf("Инцидент в процессе") !== -1 && (
                        <div className="min-h-[45px] break-all flex gap-2">
                          <span className="w-[50%]">
                            <strong>
                              {fields.find((field: any) => field.key === "QAIncidentListBlock" && !field.hide) &&
                                fields.find((field: any) => field.key === "QAIncidentListBlock" && !field.hide)[
                                "title"
                                ]}
                              :
                            </strong>
                          </span>{" "}
                          <span className="w-[50%]">{incCardQuestionsEml["QAIncidentListBlock"]}</span>
                        </div>
                      )) || (
                          <div className="min-h-[45px] break-all flex gap-2">
                            <span className="w-[50%]">
                              <strong>
                                {fields.find((field: any) => field.key === "QAIncidentList" && !field.hide) &&
                                  fields.find((field: any) => field.key === "QAIncidentList" && !field.hide)["title"]}
                                :
                              </strong>
                            </span>{" "}
                            <span className="w-[50%]">{incCardQuestionsEml["QAIncidentList"]}</span>
                          </div>
                        )}
                    </FlexCol>
                  )}
                  {incCard.TypeIncident.ID === incTypes.safe && (
                    <FlexCol className="border-r border-[#004465] px-2 gap-2 pb-5">
                      <div className="min-h-[45px] break-all gap-2 flex">
                        <span className="w-[50%]">
                          <strong>
                            {fields.find((field: any) => field.key === "SafeIncClassification" && !field.hide) &&
                              fields.find((field: any) => field.key === "SafeIncClassification" && !field.hide)[
                              "title"
                              ]}
                            :
                          </strong>
                        </span>{" "}
                        <span className="w-[50%]">
                          {(incCardQuestionsEml["SafeIncClassification"] &&
                            incCardQuestionsEml["SafeIncClassification"]["name"]) ||
                            "-"}
                        </span>
                      </div>
                      <div className="min-h-[45px] break-all gap-2 flex">
                        <span className="w-[50%]">
                          <strong>
                            {fields.find((field: any) => field.key.indexOf("SafeIncTypeSIF") !== -1) &&
                              fields.find((field: any) => field.key.indexOf("SafeIncTypeSIF") !== -1)["title"]}
                            :
                          </strong>
                        </span>{" "}
                        <span className="w-[50%]">
                          {incCardQuestionsEml[
                            Object.keys(incCardQuestionsEml).find((key) => key.indexOf("SafeIncTypeSIF") !== -1)
                          ] || "-"}
                        </span>
                      </div>
                      <div className="min-h-[45px] break-all gap-2 flex">
                        <span className="w-[50%]">
                          <strong>
                            {fields.find((field: any) => field.key.indexOf("SafeIncInjuryType") !== -1) &&
                              fields.find((field: any) => field.key.indexOf("SafeIncInjuryType") !== -1)["title"]}
                            :
                          </strong>
                        </span>{" "}
                        <span className="w-[50%]">
                          {(Object.keys(incCardQuestionsEml).find((key) => key.indexOf("SafeIncInjuryType") !== -1) &&
                            incCardQuestionsEml[
                            Object.keys(incCardQuestionsEml).find((key) => key.indexOf("SafeIncInjuryType") !== -1)
                            ]["name"]) ||
                            "-"}
                        </span>
                      </div>
                      <div className="min-h-[45px] break-all gap-2 flex">
                        <span className="w-[50%]">
                          <strong>
                            {fields.find((field: any) => field.key === "SafeIncRiskSubcategory" && !field.hide) &&
                              fields.find((field: any) => field.key === "SafeIncRiskSubcategory" && !field.hide)[
                              "title"
                              ]}
                            :
                          </strong>
                        </span>{" "}
                        <span className="w-[50%]">
                          {(incCardQuestionsEml["SafeIncRiskSubcategory"] &&
                            incCardQuestionsEml["SafeIncRiskSubcategory"]["name"]) ||
                            "-"}
                        </span>
                      </div>
                    </FlexCol>
                  )}
                  {incCard.TypeIncident.ID === incTypes.e && (
                    <FlexCol className="border-r border-[#004465] px-2 gap-2 pb-5">
                      <div className="min-h-[45px] break-all gap-2 flex">
                        <span className="w-[50%]">
                          <strong>
                            {fields.find((field: any) => field.key === "EnvIncClassification" && !field.hide) &&
                              fields.find((field: any) => field.key === "EnvIncClassification" && !field.hide)["title"]}
                            :
                          </strong>{" "}
                        </span>{" "}
                        <span className="w-[50%]">
                          {(incCardQuestionsEml["EnvIncClassification"] &&
                            incCardQuestionsEml["EnvIncClassification"]["name"]) ||
                            "-"}
                        </span>
                      </div>
                      <div className="min-h-[45px] break-all gap-2 flex">
                        <span className="w-[50%]">
                          <strong>
                            {fields.find((field: any) => field.key === "EnvIncValueEnvironment" && !field.hide) &&
                              fields.find((field: any) => field.key === "EnvIncValueEnvironment" && !field.hide)[
                              "title"
                              ]}
                            :
                          </strong>{" "}
                        </span>{" "}
                        <span className="w-[50%]">
                          {(incCardQuestionsEml["EnvIncValueEnvironment"] &&
                            incCardQuestionsEml["EnvIncValueEnvironment"].length > 0 &&
                            incCardQuestionsEml["EnvIncValueEnvironment"].join(",")) ||
                            "-"}
                        </span>
                      </div>
                      <div className="min-h-[45px] break-all gap-2 flex">
                        <span className="w-[50%]">
                          <strong>
                            {fields.find((field: any) => field.key === "EnvIncSIVRelated" && !field.hide) &&
                              fields.find((field: any) => field.key === "EnvIncSIVRelated" && !field.hide)["title"]}
                            :
                          </strong>{" "}
                        </span>{" "}
                        <span className="w-[50%]">{incCardQuestionsEml["EnvIncSIVRelated"]}</span>
                      </div>
                      <div className="min-h-[45px] break-all flex gap-2">
                        <span className="w-[50%]">
                          <strong>
                            {fields.find((field: any) => field.key === "EnvIncLegalReq" && !field.hide) &&
                              fields.find((field: any) => field.key === "EnvIncLegalReq" && !field.hide)["title"]}
                            :
                          </strong>{" "}
                        </span>{" "}
                        <span className="w-[50%]">{incCardQuestionsEml["EnvIncLegalReq"]}</span>
                      </div>
                    </FlexCol>
                  )}
                  {incCard.TypeIncident.ID === 4 && (
                    <FlexCol className="border-r border-[#004465] px-2 gap-2 pb-5">
                      <div className="min-h-[45px] break-all flex gap-2">
                        <span className="w-[50%]">
                          <strong>
                            {fields.find((field: any) => field.key === "MIncCriteriaIncident") &&
                              fields.find((field: any) => field.key === "MIncCriteriaIncident")["title"]}
                            :
                          </strong>
                        </span>
                        <span className="w-[50%]">
                          {(incCardQuestionsEml.hasOwnProperty("MIncCriteriaIncident") &&
                            incCardQuestionsEml["MIncCriteriaIncident"]) ||
                            "-"}
                        </span>
                      </div>
                      <div className="min-h-[45px] break-all flex gap-2">
                        <span className="w-[50%]">
                          <strong>
                            {fields.find((field: any) => field.key === "MIncDirection" && !field.hide) &&
                              fields.find((field: any) => field.key === "MIncDirection" && !field.hide)["title"]}
                            :
                          </strong>
                        </span>
                        <span className="w-[50%]">
                          {(incCardQuestionsEml["MIncDirection"] && incCardQuestionsEml["MIncDirection"]["name"]) ||
                            "-"}
                        </span>
                      </div>
                      <div className="min-h-[45px] break-all flex gap-2">
                        <span className="w-[50%]">
                          <strong>
                            {fields.find((field: any) => field.key === "MIncReasonType" && !field.hide) &&
                              fields.find((field: any) => field.key === "MIncReasonType" && !field.hide)["title"]}
                            :
                          </strong>
                        </span>
                        <span className="w-[50%]">
                          {(incCardQuestionsEml["MIncReasonType"] && incCardQuestionsEml["MIncReasonType"]["name"]) ||
                            "-"}
                        </span>
                      </div>
                      <div className="min-h-[45px] break-all flex gap-2">
                        <span className="w-[50%]">
                          <strong>
                            {fields.find((field: any) => field.key === "MIncDowntime" && !field.hide) &&
                              fields.find((field: any) => field.key === "MIncDowntime" && !field.hide)["title"]}
                            :
                          </strong>
                        </span>
                        <span className="w-[50%]">{incCardQuestionsEml["MIncDowntime"]}</span>
                      </div>
                      <div className="min-h-[45px] flex gap-2">
                        <span className="w-[50%]">
                          <strong>
                            {fields.find((field: any) => field.key === "MIncEmergencyPurchaseCost" && !field.hide) &&
                              fields.find((field: any) => field.key === "MIncEmergencyPurchaseCost" && !field.hide)[
                              "title"
                              ]}
                            :
                          </strong>
                        </span>
                        <span className="w-[50%] break-all">{incCardQuestionsEml["MIncEmergencyPurchaseCost"]}</span>
                      </div>
                      <div className="min-h-[45px] break-all flex gap-2">
                        <span className="w-[50%]">
                          <strong>
                            {fields.find((field: any) => field.key === "MIncTypeOfLostProduct" && !field.hide) &&
                              fields.find((field: any) => field.key === "MIncTypeOfLostProduct" && !field.hide)[
                              "title"
                              ]}
                            :
                          </strong>
                        </span>
                        <span className="w-[50%]">
                          {(incCardQuestionsEml["MIncTypeOfLostProduct"] &&
                            incCardQuestionsEml["MIncTypeOfLostProduct"]["name"]) ||
                            "-"}
                        </span>
                      </div>
                      <div className="min-h-[45px] break-all flex gap-2">
                        <span className="w-[50%]">
                          <strong>
                            {fields.find((field: any) => field.key === "MIncQuantityOfLostProduct" && !field.hide) &&
                              fields.find((field: any) => field.key === "MIncQuantityOfLostProduct" && !field.hide)[
                              "title"
                              ]}
                            :
                          </strong>
                        </span>
                        <span className="w-[50%]">{incCardQuestionsEml["MIncQuantityOfLostProduct"]}</span>
                      </div>
                    </FlexCol>
                  )}
                </FlexCol>
                <FlexCol className="w-[70%]">
                  <FlexRow className="w-full h-full">
                    <FlexCol className="border-r border-[#004465] h-full w-[50%] px-2">{incCard.Description}</FlexCol>
                    <FlexCol className="h-full w-[50%] px-2">
                      <ul>
                        {card5WayTree
                          .filter((tree: any) => tree.root)
                          .map((tree: any, idx: number) => (
                            <>
                              <li>
                                <strong>{idx + 1}.</strong> {tree.reason}
                              </li>
                              <br />
                            </>
                          ))}
                      </ul>
                    </FlexCol>
                  </FlexRow>
                  {incCard.TypeIncident.ID === incTypes.m && (
                    <FlexCol className="pb-5">
                      <FlexRow className="w-full min-h-[45px] break-all text-[#FFFFFF] items-center">
                        <FlexCol className="w-full bg-[#00629B] text-[#FFFFFF] min-h-[45px] break-all justify-center items-center pb-5">
                          Оборудование
                        </FlexCol>
                      </FlexRow>
                      <FlexRow className="w-full gap-2 px-2">
                        <FlexRow className="w-[50%] items-center gap-2">
                          <div className="min-h-[45px] flex mr-2">
                            <strong>SAP номер сообщения:</strong>
                          </div>
                          <div className="min-h-[45px] break-all flex">
                            {incCardQuestionsEml?.["MIncEq"]?.[0]?.["SAP_MESSAGE"] || "-"}
                          </div>
                        </FlexRow>
                        <FlexRow className="w-[50%] items-center gap-2">
                          <div className="min-h-[45px] break-all flex mr-2">
                            <strong>Производитель оборудования:</strong>
                          </div>
                          <div className="min-h-[45px] break-all flex">
                            {incCardQuestionsEml?.["MIncEq"]?.[0]?.["SAP"]?.["Manufacturer"] || "-"}
                          </div>
                        </FlexRow>
                      </FlexRow>
                      <FlexRow className="w-full gap-2 px-2">
                        <FlexRow className="w-[50%] items-center gap-2">
                          <div className="min-h-[45px] break-all flex mr-2">
                            <strong>SAP № технического места:</strong>
                          </div>
                          <div className="min-h-[45px] break-all flex">
                            {incCardQuestionsEml?.["MIncEq"]?.[0]?.["SAP"]?.["SAP"] || "-"}
                          </div>
                        </FlexRow>
                        <FlexRow className="w-[50%] items-center gap-2">
                          <div className="min-h-[45px] break-all flex mr-2">
                            <strong>Модель оборудования:</strong>
                          </div>
                          <div className="min-h-[45px] break-all flex">
                            {incCardQuestionsEml?.["MIncEq"]?.[0]?.["SAP"]?.["Model"] || "-"}
                          </div>
                        </FlexRow>
                      </FlexRow>
                      <FlexRow className="w-full gap-2 px-2">
                        <FlexRow className="w-[50%] items-center gap-2">
                          <div className="min-h-[45px] break-all flex items-center mr-2">
                            <strong>Название оборудования:</strong>
                          </div>
                          <div className="min-h-[45px] break-all flex items-center">
                            {incCardQuestionsEml?.["MIncEq"]?.[0]?.["SAP"]?.["Title"] || "-"}
                          </div>
                        </FlexRow>
                        <FlexRow className="w-[50%] items-center gap-2">
                          <div className="min-h-[45px] break-all flex items-center mr-2">
                            <strong>Тип оборудования</strong>
                          </div>
                          <div className="min-h-[45px] break-all flex items-center">
                            {incCardQuestionsEml?.["MIncEq"]?.[0]?.["SAP"]?.["TypeEquipment"] || "-"}
                          </div>
                        </FlexRow>
                      </FlexRow>
                    </FlexCol>
                  )}
                </FlexCol>
              </FlexRow>
              <FlexRow className="w-full bg-[#00629B] min-h-[45px] break-all text-[#FFFFFF] items-center">
                <FlexCol className="w-[50%] min-h-[45px] break-all items-center justify-center mb-5">Фото</FlexCol>
                <FlexCol className="w-[50%] min-h-[45px] break-all items-center justify-center mb-5">Действия</FlexCol>
              </FlexRow>
              <FlexRow className="w-full">
                <div className="w-[50%] flex min-h-[45px] break-all items-center"></div>
                {actionsEml.length > 0 && (
                  <FlexCol className="w-[50%]">
                    <FlexRow className="w-full">
                      <div className="w-[15%] min-h-[45px] break-all items-center px-2">
                        <strong>№</strong>
                      </div>
                      <div className="w-[60%] min-h-[45px] break-all items-center px-2">
                        <strong>Описание</strong>
                      </div>
                      <div className="w-[25%] min-h-[45px] break-all items-center px-2">
                        <strong>Срок выполнения</strong>
                      </div>
                    </FlexRow>
                    {actionsEml.map((action: any) => (
                      <FlexRow className="w-full">
                        <div className="w-[15%] min-h-[45px] break-all items-center px-2">
                          <strong>{action.idx}</strong>
                        </div>
                        <div className="w-[60%] min-h-[45px] break-all items-center px-2">{action.description}</div>
                        <div className="w-[25%] min-h-[45px] break-all items-center px-2">{action.date}</div>
                      </FlexRow>
                    ))}
                  </FlexCol>
                )}
              </FlexRow>
            </FlexCol>
          </FlexCol>
        )}
      </Modal>
    </>
  );
};

export default IncidentCard;
